import secureLocalStorage from "react-secure-storage";
import { CircularProgress } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import LinearProgress from "@material-ui/core/LinearProgress";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { process } from "@progress/kendo-data-query";
import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Popup } from "@progress/kendo-react-popup";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { Component } from "react";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import Api from "../../Services/Api";
import "../../Styles/Cart.scss";
import BarChartContainer from "../Dashboard/BarChart";
import BurnDownChartContainer from "../Dashboard/BurnDownChart";
import HeatMapChartContainer from "../Dashboard/HeatMapChart";
import HeatMapTimeStamp from "../Dashboard/HeatMapTimeStamp";
import LineChartContainer from "../Dashboard/LineChart";
import { MitigationDetails } from "../Dashboard/MitigationDetails";
import MitigationView from "../Dashboard/MitigationView";
import PieChartContainer from "../Dashboard/PieChart";
import CheckBox from "./CheckBox";
import CurrencyFormat from "./Component/CurrencyFormat";
import ExistingControlCell from "./Component/ExistingControlCell";
import ImpactEditComponent from "./Component/ImpactEditComponent";
import PrePostComponenant from "./Component/PrePostComponenant";
import RiskCauseCell from "./Component/RiskCauseCell";
import RiskDescriptionCell from "./Component/RiskDescriptionCell";
import StatusComponent from "./Component/StatusComponent";
import * as moment from "moment";
import { formatNumber } from "@telerik/kendo-intl";
import DataReportForRisk from "../Dashboard/DataReportForRisk";
import DataReportForAction from "../Dashboard/DataReportForAction";
import TileChart from "../Dashboard/TileChart";
import RichTextChart from "../Dashboard/RichTextChart";
import Histogramwidget from "../Dashboard/HistogramWidget";
import QualitativeImpactEditComponent from "./Component/QualitativeImpactEditComponent";
import TrendingLineChart from "../Dashboard/TrendingLineChart";
import { ActivitiesDetails } from "../Tasks/ActivitiesDetails";
import TaskKPITileChart from "../TaskKPITileChart";

const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#009660",
    },
  },
});

export default class Cart extends Component {
  gridPDFExport;
  // _exporter;

  constructor(props) {
    super(props);
    this.state = {
      impactMaster: [],
      showSecion: undefined,
      viewTemplate: true,
      templateList: [],
      mitigationData: [],
      chartData: [],
      riskList: [],
      attachmentLoadingFlag: false,
      AttachmentLoadingFlagForAction: false,
      mailDataBytes: [],
      emailSuggestion: [],
      customFieldsmaster: [],
      emailloader: false,
      showEmailTemplate: false,
      name: "",
      description: "",
      skip: 0,
      take: 10,
      dataState: {
        sort: [{ field: "code", dir: "asc" }],
        take: 10,
        skip: 0,
      },
      HeatMapConfigDataOpportunity: [],
      HeatMapConfigDataThreat: [],
      dynamicHeatmapProbabilityRange: [],
      isValid: "",
      isRiskValid: "",
      taskList: [],
      taskActionList: [],
    };
    this._exporterAction = React.createRef();
    this._exporterRisk = React.createRef();
    this._exporterTask = React.createRef();
    this._exporterTaskAction = React.createRef();
    this._container = React.createRef();
    this._pdfExportComponent = React.createRef();
    this.expandChange = this.expandChange.bind(this);
    this.expandChangeTask = this.expandChangeTask.bind(this);
    this.onTagsChangeTo = this.onTagsChangeTo.bind(this);
    this.onTagsChangeCC = this.onTagsChangeCC.bind(this);
  }
  componentDidMount() {
    this.isAuthorizeUse();
  }
  isAuthorizeUse = async () => {
    if (!secureLocalStorage.getItem("authToken")) {
      if (this.props.match.params.id) {
        this.props.history.push({
          pathname: `/tenant/${this.props.match.params.id}`,
        });
      } else {
        this.props.history.push({
          pathname: "/",
        });
      }
    } else {
      this.GetCartList();
      this.getEmailSuggestion();
      this.getMatrixColorCodes();
      this.getCustomField();
    }
  };

  getMatrixColorCodes = async () => {
    try {
      // var req = {
      //   WorkstreamId: 0,
      // };
      let response = await Api.MatrixColor();
      if (response.status === 200) {
        // normal,opportunity
        let normal_opp = response.matrixColor.find(
          (item) => item.riskType === "opportunity"
        );
        let opp_colorJsonData = JSON.parse(normal_opp.colorJsonData);

        //  normal,threat
        let normal_threat = response.matrixColor.find(
          (item) => item.riskType === "threat"
        );
        let threat_colorJsonData = JSON.parse(normal_threat.colorJsonData);
        this.setState({
          HeatMapConfigDataThreat: threat_colorJsonData,
          HeatMapConfigDataOpportunity: opp_colorJsonData,

          heatMapCount: response.heatmapCount,
          dynamicHeatmapProbabilityRange:
            response.dynamicHeatmapProbabilityRange,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  sendEmail(data) {
    this.setState({ showSecion: "sendemail" });
    this.generateAttachments(data);
  }
  viewReports(id) {
    this.setState({ showSecion: "viewreports",chartData:[] });
    this.getWidgetBycart(id);
  }
  viewRisks(id) {
    this.setState({ showSecion: "viewrisks" });
    this.getRiskDataset(id);
  }
  viewAction(id) {
    this.setState({ showSecion: "viewActions" });
    this.getActionDataByViewId(id);
  }
  viewTask(id) {
    this.setState({ showSecion: "viewTask" });
    this.getTaskDatasetView(id);
  }
  viewTaskAction(id) {
    this.setState({ showSecion: "viewTaskAction" });
    this.getTaskActionDatasetView(id);
  }
  viewWorkstream(id) {
    this.setState({ showSecion: "viewWorkStream" });
    this.getRiskListByOrgUnitIds([id]);
  }
  viewWorkstreamTask(id) {
    this.setState({ showSecion: "viewWorkStreamTask" });
    this.getTasksById([id]);
  }
  discardMail() {
    this.setState({
      showSecion: "",
      Subject: "",
      Body: "",
      Email: "",
      mailDataBytes: [],
    });
  }

  getTasksById = async (idList) => {
    try {
      var request = {
        workstreamIds: idList,
        ScreenFrom: "Task",
      };
      this.setState({
        ...this.state,
        loader: true,
        taskList: [],
        showSecion: "viewWorkStreamTask",
      });
      let response = await Api.getTasksById(request);
      if (response.status === 200) {
        response.taskRegisters.map((taskReg) => {
          if (taskReg.originalCompletionDate) {
            taskReg.originalCompletionDate = new Date(
              taskReg.originalCompletionDate
            );
          }
          if (taskReg.projectedCompletionDate) {
            taskReg.projectedCompletionDate = new Date(
              taskReg.projectedCompletionDate
            );
          }
          if (taskReg.actualCompletionDate) {
            taskReg.actualCompletionDate = new Date(
              taskReg.actualCompletionDate
            );
          }
          if (taskReg.proximityAlertDate) {
            taskReg.proximityAlertDate = new Date(taskReg.proximityAlertDate);
          }
          if (taskReg.updatedDate) {
            var time = moment(taskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            taskReg.updatedDate = taskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }
          if (taskReg.createdDate) {
            let time = moment(taskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            taskReg.createdDate = taskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (taskReg.closedDate) {
            let time = moment(taskReg.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            taskReg.closedDate = taskReg.closedDate ? new Date(closedDate) : "";
          }

          if (taskReg.isClosed === false) {
            taskReg.isClosed = "Open";
          } else {
            taskReg.isClosed = "Closed";
          }
          if (taskReg.isApproved === false) {
            taskReg.isApproved = "No";
          } else {
            taskReg.isApproved = "Yes";
          }
        });
        await this.createDynamicDropdowns(response.taskRegisters);
        this.setState({
          ...this.state,
          loader: false,
          taskList: response.taskRegisters,
        });
      } else {
        this.setState({ ...this.state, loader: false, taskList: [] });
      }
    } catch (err) {
      console.error(err);
      this.setState({ ...this.state, loader: false, taskList: [] });
    }
  };

  getTaskDatasetView = async (id) => {
    try {
      this.setState({ ...this.state, loader: true, showSecion: "viewTask" });
      var request = {
        viewId: id,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getTaskDatasetView(request);
      if (response.status === 200) {
        response.taskRegisters.map((riskReg) => {
          if (riskReg.originalCompletionDate) {
            riskReg.originalCompletionDate = new Date(
              riskReg.originalCompletionDate
            ); //riskReg.originalCompletionDate? moment(new Date(riskReg.originalCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.projectedCompletionDate) {
            riskReg.projectedCompletionDate = new Date(
              riskReg.projectedCompletionDate
            ); //riskReg.projectedCompletionDate? moment(new Date(riskReg.projectedCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.actualCompletionDate) {
            riskReg.actualCompletionDate = new Date(
              riskReg.actualCompletionDate
            ); //riskReg.actualCompletionDate? moment(new Date(riskReg.actualCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.proximityAlertDate) {
            riskReg.proximityAlertDate = new Date(riskReg.proximityAlertDate); //riskReg.proximityAlertDate? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }
          if (riskReg.createdDate) {
            let time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (riskReg.closedDate) {
            let time = moment(riskReg.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            riskReg.closedDate = riskReg.closedDate ? new Date(closedDate) : "";
          }

          if (riskReg.isClosed === false) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg.isApproved === false) {
            riskReg.isApproved = "No";
          } else {
            riskReg.isApproved = "Yes";
          }
        });
        await this.createDynamicDropdowns(response.taskRegisters);
        this.setState({
          ...this.state,
          loader: false,
          taskList: response.taskRegisters,
        });
      } else {
        this.setState({ ...this.state, loader: false, taskList: [] });
      }
    } catch (err) {
      this.setState({ ...this.state, loader: false, taskList: [] });
    }
  };

  getTaskActionDatasetView = async (id) => {
    try {
      this.setState({
        ...this.state,
        loader: true,
        showSecion: "viewTaskAction",
      });
      var request = {
        viewId: id,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.getTaskActionDatasetView(request);
      if (response.status === 200) {
        response.taskActions.map((riskReg) => {
          if (riskReg.originalCompletionDate) {
            riskReg.originalCompletionDate = new Date(
              riskReg.originalCompletionDate
            ); //riskReg.originalCompletionDate? moment(new Date(riskReg.originalCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.projectedCompletionDate) {
            riskReg.projectedCompletionDate = new Date(
              riskReg.projectedCompletionDate
            ); //riskReg.projectedCompletionDate? moment(new Date(riskReg.projectedCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.actualCompletionDate) {
            riskReg.actualCompletionDate = new Date(
              riskReg.actualCompletionDate
            ); //riskReg.actualCompletionDate? moment(new Date(riskReg.actualCompletionDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.proximityAlertDate) {
            riskReg.proximityAlertDate = new Date(riskReg.proximityAlertDate); //riskReg.proximityAlertDate? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY"):null;
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }
          if (riskReg.createdDate) {
            let time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (riskReg.closedDate) {
            let time = moment(riskReg.closedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let closedDate = time;
            riskReg.closedDate = riskReg.closedDate ? new Date(closedDate) : "";
          }

          if (riskReg.isClosed === false) {
            riskReg.isClosed = "Open";
          } else {
            riskReg.isClosed = "Closed";
          }
          if (riskReg.isApproved === false) {
            riskReg.isApproved = "No";
          } else {
            riskReg.isApproved = "Yes";
          }
        });
        await this.createDynamicDropdowns(response.taskActions);
        this.setState({
          ...this.state,
          loader: false,
          taskActionList: response.taskActions,
        });
      } else {
        this.setState({ ...this.state, loader: false, taskActionList: [] });
      }
    } catch (err) {
      this.setState({ ...this.state, loader: false, taskActionList: [] });
    }
  };

  getRiskListByOrgUnitIds = async (idList) => {
    try {
      var request = {
        OrgUnitIds: idList,
      };
      this.setState({
        ...this.state,
        loader: true,
        showSecion: "viewWorkStream",
      });

      let response = await Api.getRiskForOrgUnit(request);
      if (response.status === 200) {
        response.riskRegister.map((riskReg) => {
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (riskReg.createdDate) {
            riskReg.createdDate = new Date(riskReg.createdDate);
          }
          if (riskReg.riskTypeNames) {
            riskReg["riskTypeNames"] = riskReg.riskTypeNames.toString();
          }
        });
        var temp = response.isPrimeWorkstreams;
        this.setState({
          ...this.state,
          isValid: temp,
        });

        let impactMaster = [];
        if (response.riskRegister && response.riskRegister.length > 0) {
          impactMaster = response.riskRegister[0].impactResponse;
        }
        this.setState({ ...this.state, impactMaster: impactMaster });
        await this.createDynamicDropdowns(response.riskRegister);
        await this.createDynamicCols(response.riskRegister);

        this.setState({
          ...this.state,

          riskList: response.riskRegister,
          riskTemp: response.riskRegister,
          loader: false,
        });
      } else {
        this.setState({
          ...this.state,
          riskList: [],
          riskTemp: [],
          loader: false,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  generateAttachments = async (templateData) => {
    var attachmentList = [];
    try {
      var requestParams = {
        TemplateIds: [templateData.templateId],
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      this.setState({
        ...this.state,
        emailloader: true,
        showSecion: "sendemail",
        currentTemplate: templateData.name,
        mailDataBytes: [],
        attachmentLoadingFlag: true,
      });
      let response = await Api.GetCartItems(requestParams);
      if (response.status === 200 && response.templateList.length > 0) {
        var chartComponentArray = await this.getReportAttachments(
          response.templateList[0].chartData
        );

        if (response.templateList[0].riskView) {
          response.templateList[0].riskView.map(async (item) => {
            setTimeout(async () => {
              await this.getRiskAttachments(item);
            }, 1000);
          });
        }

        if (response.templateList[0].actionView) {
          response.templateList[0].actionView.map(async (item) => {
            setTimeout(async () => {
              await this.getActionAttachments(item);
            }, 1000);
          });
        }

        if (response.templateList[0].taskViews) {
          response.templateList[0].taskViews.map(async (item) => {
            setTimeout(async () => {
              await this.getTaskAttachments(item);
            }, 1000);
          });
        }

        if (response.templateList[0].taskActionViews) {
          response.templateList[0].taskActionViews.map(async (item) => {
            setTimeout(async () => {
              await this.getTaskActionsAttachments(item);
            }, 1000);
          });
        }

        setTimeout(async () => {
          await this.convertHtmlTODataURIV1();
          setTimeout(() => {
            this.setState({
              ...this.state,
              emailloader: false,
              chartComponentArray: [],
            });
          }, 5000);
        }, 5000);
      } else {
        this.setState({ ...this.state, emailloader: false });
      }
    } catch (error) {
      this.setState({ ...this.state, emailloader: false });
      console.error(error);
    }
  };

  expandChange(event) {
    event.dataItem.expanded = event.value;
    let riskRegisterId = event.dataItem.riskRegisterId;
    this.setState({ ...this.state });
    if (!event.value || event.dataItem.mitigationResps) {
      return;
    }
    let data = this.state.riskList.slice();
    let index = data.findIndex((d) => d.riskRegisterId === riskRegisterId);
    data[index].mitigationResps = this.state.riskList.filter(
      (d) => d.riskRegisterId === riskRegisterId
    );
    this.setState({ riskList: data });
  }

  expandChangeTask(event) {
    event.dataItem.expanded = event.value;
    let taskRegisterId = event.dataItem.taskRegisterId;
    this.setState({ ...this.state });
    if (!event.value || event.dataItem.taskActions) {
      return;
    }
    let data = this.state.taskList.slice();
    let index = data.findIndex((d) => d.taskRegisterId === taskRegisterId);
    data[index].taskActions = this.state.taskList.filter(
      (d) => d.taskRegisterId === taskRegisterId
    );
    this.setState({ taskList: data });
  }

  getChartContainerV1 = (chart) => {
    var componant = <div></div>;
    if (chart.widgetType === "LINE_CHART") {
      componant = (
        <LineChartContainer
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
        />
      );
    }else if (chart.widgetType == "TRENDING_CHART") {
      componant = (
        <TrendingLineChart
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
        />
      );
    } else if (chart.widgetType === "BAR_CHART") {
      componant = (
        <BarChartContainer
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
        />
      );
    } else if (chart.widgetType === "BURN_DOWN_CHART") {
      componant = (
        <BurnDownChartContainer
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
        />
      );
    } else if (chart.widgetType === "PIE_CHART") {
      componant = (
        <PieChartContainer
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
          overAllDownlad={true}
        />
      );
    } else if (chart.widgetType === "HEAT_MAP" && chart.timeStamp === false) {
      componant = (
        <HeatMapChartContainer
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
        />
      );
    } else if (chart.widgetType === "HEAT_MAP" && chart.timeStamp === true) {
      componant = (
        <HeatMapTimeStamp
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
        />
      );
    }
    //new
    else if (chart.widgetType === "DOUGHNUT_CHART") {
      componant = (
        <Histogramwidget
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
          viewDataSetIcon={false}
        />
      );
    } else if (chart.widgetType === "KPI" && chart.reportType != "Task") {
      componant = (
        <TileChart
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          refreshTextWidget={this.refreshTextWidget}
          flag={false}
          expandIcon={false}
        />
      );
    } else if (chart.widgetType === "KPI" && chart.reportType === "Task") {
      componant = (
        <TaskKPITileChart
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          refreshTextWidget={this.refreshTextWidget}
          flag={false}
          expandIcon={false}
        />
      );
    } else if (chart.widgetType === "TEXT_WIDGET") {
      componant = (
        <RichTextChart
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          refreshTextWidget={this.refreshTextWidget}
          flag={false}
          expandIcon={false}
        />
      );
    }
    return componant;
  };

  convertHtmlTODataURIV1 = async () => {
    try {
      this.state.chartComponentArray.map(async (item, index) => {
        if (item.chartTypePdf === "TEXT_WIDGET") {
          var pdf = new jsPDF("pt", "px", [595.28, 841.89]);
          var options = {
            width: 400,
            height: 400,
          };

          const input = document.getElementById("c" + item.chartPdfId);
          const iframe = input.getElementsByTagName("iframe");
          const screen = iframe[0]?.contentDocument?.body;
          const This = this;

          pdf.fromHTML(
            screen,
            60,
            60,
            options,
            function () {
              var dataURI = pdf.output("datauristring"); // base64 string
              let base64URI = dataURI.split(";base64,")[1];
              let name = item.chartWidName + ".pdf";
              var stringLength = base64URI.length;
              var sizeInBytes =
                4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
              var sizeInKb = sizeInBytes / 1000;
              let dataBytesArray = [];
              dataBytesArray.push({
                filename: name,
                fileData: base64URI,
                size: Math.round(sizeInKb),
              });
              This.setState({
                mailDataBytes: [...This.state.mailDataBytes, ...dataBytesArray],
              });
              //  pdf.save(widgetName+".pdf");
            },
            {
              top: 20,
              bottom: 20,
              right: 20,
              left: 20,
            }
          );
        } else if (item.chartTypePdf === "DOUGHNUT_CHART") {
          const pdf = new jsPDF("l", "mm");
          var ids = [
            "c1" + item.chartPdfId,
            "c2" + item.chartPdfId,
            "c3" + item.chartPdfId,
            "c4" + item.chartPdfId,
          ];

          for (var i = 0; i < ids.length; i++) {
            const input = document.getElementById(ids[i]);
            const canvas = await html2canvas(input);
            const imgData = canvas.toDataURL("image/png");
            pdf.addPage();
            pdf.setFillColor(24, 26, 26);
            pdf.rect(0, 0, 300, 300, "F");
            pdf.addImage(imgData, "PNG", 30, 30, 250, 180);
          }

          //   })
          pdf.deletePage(1);
          var dataURI = pdf.output("datauristring"); // base64 string
          var base64URI = dataURI.split(";base64,")[1];
          let name = item.chartWidName + ".pdf";
          var stringLength = base64URI.length;
          var sizeInBytes =
            4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
          var sizeInKb = sizeInBytes / 1000;
          let dataBytesArray = [];
          dataBytesArray.push({
            filename: name,
            fileData: base64URI,
            size: Math.round(sizeInKb),
          });
          this.setState({
            mailDataBytes: [...this.state.mailDataBytes, ...dataBytesArray],
          });
        } else if (item.chartTypePdf === "HEAT_MAP") {
          const chartId = item.chartPdfId;
          let htmlId = "#c" + item.chartPdfId;
          const originalElement = document.querySelector(htmlId);

          // Clone the element to avoid mutations
          const gridElement = originalElement.cloneNode(true);
          gridElement.id = "export_" + chartId; // New unique ID for the cloned export
          // ✅ Hide it off-screen instead of showing at bottom
          gridElement.style.position = "absolute";
          gridElement.style.top = "-9999px";
          gridElement.style.left = "-9999px";
          // gridElement.style.visibility = "hidden";

          document.body.appendChild(gridElement);

          // ========= Narrative Setup =========
          const narrativeElement = gridElement.querySelector(
            ".textnarrativeexport"
          );
          if (narrativeElement) {
            narrativeElement.style.display = "block";
            const pTag = narrativeElement.querySelector("p");
            if (pTag) {
              const narrativeText = item?.textNarrative || "";
              pTag.textContent = narrativeText;
            }
          }

          // ========= Temporary Styling =========
          const styleTag = document.createElement("style");
          styleTag.setAttribute("data-export-style", chartId);
          styleTag.innerHTML = `
    #export_${chartId} {
      background: white !important;
      font-family: "Barlow", sans-serif !important;
    }

    #export_${chartId} * {
      color: black !important;
      font-size: 12px !important;
      font-family: "Barlow", sans-serif !important;
    }

    #export_${chartId} .textnarrativeexport {
  display: block !important;
  color: black !important;
  width: 100% !important;
  max-width: 1000px !important; /* Constrain width */
  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  padding: 10px !important;
  box-sizing: border-box !important;
}

#export_${chartId} .textnarrativeexport p {
  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  font-size: 12px !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1.4;
  width: 100% !important;
  max-width: 100% !important;
}

    #export_${chartId} .wgHeader h4 {
      font-size: 12px !important;
      font-weight: normal !important;
      color: black !important;
    }

    #export_${chartId} .heatmapHeader {
      background-color: white !important;
    }
  `;
          document.head.appendChild(styleTag);

          // Force layout refresh
          gridElement.style.display = "none";
          void gridElement.offsetHeight;
          gridElement.style.display = "";

          // ========= Export to PDF =========
          try {
            const group = await drawDOM(gridElement, {
              paperSize: "auto",
              margin: "1cm",
              scale: 1,
              forcePageBreak: ".pdf-page-break",
              background: "#ffffff",
            });

            let dataURI = await exportPDF(group, {
              background: "#ffffff",
            });

            // saveAs(dataURI, `${widgetName}.pdf`);
         

          let base64URI = dataURI.split(";base64,")[1];
          let name = item.chartWidName + ".pdf";
          var stringLength = base64URI.length;
          var sizeInBytes =
            4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
          var sizeInKb = sizeInBytes / 1000;
          let dataBytesArray = [];
          dataBytesArray.push({
            filename: name,
            fileData: base64URI,
            size: Math.round(sizeInKb),
          });
          this.setState({
            mailDataBytes: [...this.state.mailDataBytes, ...dataBytesArray],
          });
           } catch (error) {
            console.error("PDF export error:", error);
          }
        } else {
          let htmlId = "#c" + item.chartPdfId;
          let gridElement = document.querySelector(htmlId);
          // 1. Find the .textnarrativeexport inside this chart
          let narrativeElement = gridElement.querySelector(
            ".textnarrativeexport"
          );

          if (narrativeElement) {
            // 2. Temporarily make it visible
            narrativeElement.style.display = "block";

            // 3. Assign new text value inside the <p> tag
            let pTag = narrativeElement.querySelector("p");
            if (pTag) {
              const narrativeText = item?.textNarrative || "";
              pTag.textContent = narrativeText;
            }
          }
          //================ transparency Start ===========================

          // Function to recursively set background to transparent for all elements
          const makeTransparent = (element, originalStyles, prefix) => {
            // Store original background
            originalStyles[`${prefix}_bg`] = element.style.backgroundColor;
            originalStyles[`${prefix}_bgImg`] = element.style.backgroundImage;

            // Set background to transparent
            element.style.backgroundColor = "transparent";
            element.style.backgroundImage = "none";

            // Process all child elements
            Array.from(element.children).forEach((child, index) => {
              makeTransparent(child, originalStyles, `${prefix}_${index}`);
            });

            return originalStyles;
          };

          // Function to restore original backgrounds
          const restoreBackgrounds = (element, originalStyles, prefix) => {
            // Restore background
            element.style.backgroundColor =
              originalStyles[`${prefix}_bg`] || "";
            element.style.backgroundImage =
              originalStyles[`${prefix}_bgImg`] || "";

            // Process all child elements
            Array.from(element.children).forEach((child, index) => {
              restoreBackgrounds(child, originalStyles, `${prefix}_${index}`);
            });
          };

          // Store original styles and make all elements transparent
          const originalStyles = {};
          makeTransparent(gridElement, originalStyles, "root");

          // Add a temporary style tag with aggressive selectors
          const styleTag = document.createElement("style");
          styleTag.innerHTML = `
      #${gridElement.id},
      #${gridElement.id} *,
      #${gridElement.id} *::before,
      #${gridElement.id} *::after {
        background-color: transparent !important;
        background-image: none !important;
        background: transparent !important;
        fill: transparent !important;
        color: black !important;
      }
        .flexLabel{
        padding-left: 15px;
      }
        /* Put these AFTER the global transparency override */
        #${gridElement.id} .originalCompletionDate {
          background-color: rgb(206, 237, 248) !important;
        }

        #${gridElement.id} .projectedCompletionDate {
          background-color: rgb(227, 241, 22) !important;
        }

        #${gridElement.id} .actualCompletionDate {
          background-color: rgb(34, 159, 204) !important;
        }
   #${gridElement.id} .mitigated{background-color: rgb(248, 220, 135) !important;}
  #${gridElement.id} .unmitigated{background-color:rgb(255, 138, 130) !important;}
  #${gridElement.id} .mitigatedend{background-color:rgb(255, 210, 70) !important;}
  #${gridElement.id} .umitigatedend{background-color: rgb(255, 99, 88) !important;}
  #${gridElement.id} .originalCompletionDate{background-color: rgb(206,237,248) !important;}
  #${gridElement.id} .projectedCompletionDate{background-color: rgb(227, 241, 22) !important;}
  #${gridElement.id} .actualCompletionDate{background-color:rgb(34,159,204) !important;}  
  #${gridElement.id} .currentValue{background-color:rgb(8, 77, 167) !important;}
   #${gridElement.id} .currentValueEnd{background-color:rgba(45, 125, 230, 1);}
  
      .textnarrativeexport {
        color: black !important;
        font-size: 12px;
        font-family: "Barlow";
        src: url("./riskwell/Assets/Fonts/Barlow-Medium.ttf");
        font-style: normal;
        padding-bottom: 10px !important;
      }
      /* Target specific Kendo chart elements */
      .k-chart-surface,
      .k-chart-area,
      .k-chart svg,
      .k-chart svg rect,
      .k-chart-plot-area,
      .k-chart-pane {
        background-color: transparent !important;
        background: transparent !important;
        fill: transparent !important;
        color: black !important;
      }
    `;
          document.head.appendChild(styleTag);

          // If this is a Kendo chart, try to update its options directly
          if (this._chart && typeof this._chart.setOptions === "function") {
            try {
              const currentOptions = this._chart.options || {};
              this._chart.setOptions({
                ...currentOptions,
                chartArea: {
                  ...currentOptions.chartArea,
                  background: "transparent",
                },
                plotArea: {
                  ...currentOptions.plotArea,
                  background: "transparent",
                },
              });
            } catch (e) {
              console.error("Error updating chart options:", e);
            }
          }

          // Force a repaint
          gridElement.style.display = "none";
          void gridElement.offsetHeight;
          gridElement.style.display = "";
          //================ transparency End ===========================

          drawDOM(gridElement, {
            //  paperSize: "A4",
            landscape: true,
          })
            .then((group) => {
              // Try to modify the group to ensure transparency
              try {
                if (group && group.children) {
                  group.children.forEach((child) => {
                    if (child.options) {
                      child.options.background = "transparent";
                    }
                  });
                }
              } catch (e) {
                console.error("Error modifying group:", e);
              }
              return exportPDF(group, {
                background: "transparent",
              });
            })
            .then((dataURI) => {
              let base64URI = dataURI.split(";base64,")[1];
              let name = item.chartWidName + ".pdf";
              var stringLength = base64URI.length;
              var sizeInBytes =
                4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
              var sizeInKb = sizeInBytes / 1000;
              let dataBytesArray = [];
              dataBytesArray.push({
                filename: name,
                fileData: base64URI,
                size: Math.round(sizeInKb),
              });
              this.setState({
                mailDataBytes: [...this.state.mailDataBytes, ...dataBytesArray],
              });
            }).finally(() => {
              // Clean up - remove the style tag
              document.head.removeChild(styleTag);

              // Restore original backgrounds
              restoreBackgrounds(gridElement, originalStyles, "root");

              // If we modified the chart options, try to restore them
              if (this._chart && typeof this._chart.setOptions === "function") {
                try {
                  this._chart.refresh();
                } catch (e) {
                  console.error("Error refreshing chart:", e);
                }
              }

              if (narrativeElement) {
                // 5. After export, remove the temporary text or hide the element
                narrativeElement.style.display = "none";
                let pTag = narrativeElement.querySelector("p");
                if (pTag) {
                  pTag.textContent = ""; // clear the text if needed
                }
              }
            });
        }
      });
    } catch (err) {}
    return true;
  };
  // convertHtmlTODataURI = async () => {
  //   try {
  //     this.state.chartComponentArray.map(async (item, index) => {
  //       if (item.chartTypePdf === "DOUGHNUT_CHART") {
  //         console.log(item);
  //         const pdf = new jsPDF("pt", "mm");
  //         let ids = [
  //           "c1" + item.chartPdfId,
  //           "c2" + item.chartPdfId,
  //           "c3" + item.chartPdfId,
  //           "c4" + item.chartPdfId,
  //         ];
  //         const input1 = document.getElementById(ids[0]),
  //           canvas1 = await html2canvas(input1);
  //         const imgData1 = canvas1.toDataURL("image/png");
  //         pdf.addPage();
  //         pdf.addImage(imgData1, "PNG", 0, 0, 210, 300);

  //         const input2 = document.getElementById(ids[1]),
  //           canvas2 = await html2canvas(input2);
  //         const imgData2 = canvas2.toDataURL("image/png");
  //         pdf.addPage();
  //         pdf.addImage(imgData2, "PNG", 0, 0, 210, 300);

  //         const input3 = document.getElementById(ids[2]),
  //           canvas3 = await html2canvas(input3);
  //         const imgData3 = canvas3.toDataURL("image/png");
  //         pdf.addPage();
  //         pdf.addImage(imgData3, "PNG", 0, 0, 210, 300);

  //         const input4 = document.getElementById(ids[3]),
  //           canvas4 = await html2canvas(input4);
  //         const imgData4 = canvas4.toDataURL("image/png");
  //         pdf.addPage();
  //         pdf.addImage(imgData4, "PNG", 0, 0, 210, 300);

  //         pdf.deletePage(1);
  //         var base = pdf.output("datauristring"); // base64 string
  //         // console.log("base64 is ", base);
  //         let base64URI = base.split(";base64,")[1];
  //         let name = item.chartWidName + ".pdf";
  //         var stringLength = base64URI.length;
  //         var sizeInBytes =
  //           4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
  //         var sizeInKb = sizeInBytes / 1000;
  //         let dataBytesArray = [];
  //         dataBytesArray.push({
  //           filename: name,
  //           fileData: base64URI,
  //           size: Math.round(sizeInKb),
  //         });
  //         this.setState({
  //           mailDataBytes: [...this.state.mailDataBytes, ...dataBytesArray],
  //         });
  //       } else {
  //         let htmlId = "#c" + item.chartPdfId;
  //         html2canvas(document.querySelector(htmlId)).then((canvas) => {
  //           const imgData = canvas.toDataURL("image/JPEG");
  //           // var doc = new jsPDF('p', 'pt','a4',true);
  //           var doc = new jsPDF("p", "mm", "a4", true);

  //           // doc.addImage(imgData, "JPEG", 0, 0);

  //           // console.log(width,height);
  //           // doc.addImage(imgData, 'PNG', 50, 120, 485, 270,'','FAST');
  //           if (
  //             item.chartTypePdf === "PIE_CHART" &&
  //             item.chartTimeStampPdf === true
  //           ) {
  //             var width = doc.internal.pageSize.getWidth();
  //             var height = doc.internal.pageSize.getHeight();
  //             doc.addImage(imgData, "JPEG", 10, 30, 180, 110, "", "FAST");
  //           } else {
  //             doc.addImage(imgData, "JPEG", 10, 50, 170, 70, "", "FAST");
  //           }

  //           // doc.save("test.pdf");
  //           var base = doc.output("datauristring"); // base64 string
  //           // console.log("base64 is ", base);
  //           let base64URI = base.split(";base64,")[1];
  //           let name = item.chartWidName + ".pdf";
  //           var stringLength = base64URI.length;
  //           var sizeInBytes =
  //             4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
  //           var sizeInKb = sizeInBytes / 1000;
  //           let dataBytesArray = [];
  //           dataBytesArray.push({
  //             filename: name,
  //             fileData: base64URI,
  //             size: Math.round(sizeInKb),
  //           });
  //           this.setState({
  //             mailDataBytes: [...this.state.mailDataBytes, ...dataBytesArray],
  //           });
  //         });
  //       }

  //       // console.log('index',index);
  //     });
  //   } catch (err) {}
  //   return true;
  // };
  getReportAttachments = async (widgetList) => {
    try {
      let chartComponentArray = [];
      await Promise.all(
        widgetList.map(async (chart, index) => {
          var chartComponent = this.getChartContainerV1(chart);
          chartComponentArray.push({
            chartHtml: chartComponent,
            chartPdfId: chart.widgetId,
            chartWidName: chart.widgetName,
            chartTypePdf: chart.widgetType,
            chartTimeStampPdf: chart.timeStamp,
            textNarrative: chart.textNarrative,
          });
        })
      );
      this.setState({
        ...this.state,
        chartComponentArray: chartComponentArray,
      });
    } catch (err) {
      console.log(err);
    }
  };

  // exportPDFWithMethod = (fileName) => {
  //   let element = this._container.current || document.body;
  //   if (element) {
  //     drawDOM(element, { paperSize: "auto" })
  //       .then((group) => {
  //         return exportPDF(group);
  //       })
  //       .then((dataURI) => {
  //         saveAs(dataURI, fileName + ".pdf");
  //         let base64URI = dataURI.split(";base64,")[1];

  //         let name = fileName + ".pdf";
  //         var stringLength = base64URI.length;
  //         var sizeInBytes =
  //           4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
  //         var sizeInKb = sizeInBytes / 1000;
  //         let dataBytesArray = [];
  //         dataBytesArray.push({
  //           filename: name,
  //           fileData: base64URI,
  //           size: Math.round(sizeInKb),
  //         });
  //         this.setState({
  //           mailDataBytes: [...this.state.mailDataBytes, ...dataBytesArray],
  //         });
  //       });
  //   } else {
  //     console.log("no ref");
  //   }
  // };

  // exportPDFWithComponent = async () => {
  //   if (this._pdfExportComponent.current) {
  //     this._pdfExportComponent.current.save();
  //   }
  // };
  // getFileFromChart = (uri, fileName) => {
  //   // var blob = this.dataURLtoFile(dataURI, fileName);
  //   // console.log("fileName", fileName);
  //   let dataURI = uri.split(";base64,")[1];

  //   let name = fileName;
  //   var stringLength = dataURI.length;
  //   var sizeInBytes = 4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
  //   var sizeInKb = sizeInBytes / 1000;
  //   let dataBytesArray = [];
  //   dataBytesArray.push({
  //     filename: name,
  //     fileData: dataURI,
  //     size: Math.round(sizeInKb),
  //   });
  //   this.setState({
  //     mailDataBytes: [...this.state.mailDataBytes, ...dataBytesArray],
  //   });
  // };
  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  getRiskAttachments = async (response) => {
    response.risks &&
      response.risks.map((riskReg) => {
        if (riskReg.proximityDate) {
          riskReg.proximityDate = new Date(riskReg.proximityDate);
        }
        if (riskReg.createdDate) {
          var time = moment(riskReg.createdDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let createdDate = time;
          riskReg.createdDate = riskReg.createdDate
            ? new Date(createdDate)
            : "";
        }
        if (riskReg.updatedDate) {
          var time = moment(riskReg.updatedDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let updatedDate = time;
          riskReg.updatedDate = riskReg.updatedDate
            ? new Date(updatedDate)
            : "";
        }
        if (riskReg.riskTypeNames) {
          riskReg["riskTypeNames"] = riskReg.riskTypeNames.toString();
        }
        let str = "";
        if (riskReg.riskImpactComments) {
          riskReg.riskImpactComments.map((cmt) => {
            str +=
              " Name:" +
              cmt.userName +
              "\n Date:" +
              moment(new Date(cmt.createdDate)).format("DD-MMM-yyyy HH:mm:ss") +
              "\n Comments: " +
              cmt.riskComment +
              "\r\n";
          });
          riskReg["progressHistory"] = str;
        } else {
          riskReg["progressHistory"] = null;
        }
        if (riskReg.isClosed) {
          riskReg.isClosed = "Open";
        } else {
          riskReg.isClosed = "Closed";
        }
        if (riskReg.closedDate) {
          riskReg.closedDate = new Date(riskReg.closedDate);
        } else {
          riskReg.closedDate = null;
        }
      });
    let impactMaster = [];
    if (response.risks && response.risks.length > 0) {
      impactMaster = response.risks[0].impactResponse;
    }
    this.setState({ ...this.state, impactMaster: impactMaster });
    await this.createDynamicDropdowns(response.risks);
    await this.createDynamicCols(response.risks);
    this.setState({
      ...this.state,
      riskList: response.risks,
      loader: false,
    });

    let riskDataUri = await this.exportRisk();
    var stringLength = riskDataUri.length;
    var sizeInBytes = 4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
    var sizeInKb = sizeInBytes / 1000;
    var riskAttachments = [];
    let fileName = response.name ? response.name.replace(" ", "_") : "Risk";
    riskAttachments.push({
      filename: fileName + ".xlsx",
      size: Math.round(sizeInKb),
      fileData: riskDataUri,
    });

    this.setState({
      riskList: [],
      mailDataBytes: [...this.state.mailDataBytes, ...riskAttachments],
    });
  };
  getActionAttachments = async (actionDatasetList) => {
    let impactMaster = [];
    if (actionDatasetList && actionDatasetList.mitigationView.length > 0) {
      impactMaster = actionDatasetList.mitigationView[0].impactResponse;
    }
    this.setState({ ...this.state, impactMaster: impactMaster });
    await this.createDynamicDropdownsForAction(
      actionDatasetList.mitigationView
    );
    await this.createDynamicColsForAction(actionDatasetList.mitigationView);
    this.setState({
      AttachmentLoadingFlagForAction: true,
      mitigationData: actionDatasetList.mitigationView,
    });

    let actionDataUri = await this.exportAction();
    var stringLength = actionDataUri.length;
    var sizeInBytes = 4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
    var sizeInKb = sizeInBytes / 1000;
    var actionAttachments = [];
    let fileName = actionDatasetList.name
      ? actionDatasetList.name.replace(" ", "_")
      : "action";
    actionAttachments.push({
      filename: fileName + ".xlsx",
      size: Math.round(sizeInKb),
      fileData: actionDataUri,
    });
    this.setState({
      mitigationData: [],
      mailDataBytes: [...this.state.mailDataBytes, ...actionAttachments],
    });

    // return actionDataUri;
  };

  getTaskAttachments = async (response) => {
    response.tasks &&
      response.tasks.map((task) => {
        if (task.originalCompletionDate) {
          task.originalCompletionDate = new Date(task.originalCompletionDate); //riskReg.originalCompletionDate? moment(new Date(riskReg.originalCompletionDate)).format("DD-MMM-YYYY"):null;
        }
        if (task.projectedCompletionDate) {
          task.projectedCompletionDate = new Date(task.projectedCompletionDate); //riskReg.projectedCompletionDate? moment(new Date(riskReg.projectedCompletionDate)).format("DD-MMM-YYYY"):null;
        }
        if (task.actualCompletionDate) {
          task.actualCompletionDate = new Date(task.actualCompletionDate); //riskReg.actualCompletionDate? moment(new Date(riskReg.actualCompletionDate)).format("DD-MMM-YYYY"):null;
        }
        if (task.proximityAlertDate) {
          task.proximityAlertDate = new Date(task.proximityAlertDate); //riskReg.proximityAlertDate? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY"):null;
        }
        if (task.updatedDate) {
          var time = moment(task.updatedDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let updatedDate = time;
          task.updatedDate = task.updatedDate ? new Date(updatedDate) : "";
        }
        if (task.createdDate) {
          let time = moment(task.createdDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let createdDate = time;
          task.createdDate = task.createdDate ? new Date(createdDate) : "";
        }
        if (task.closedDate) {
          let time = moment(task.closedDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let closedDate = time;
          task.closedDate = task.closedDate ? new Date(closedDate) : "";
        }
        let str = "";
        if (task.taskProgressComments) {
          task.taskProgressComments.map((cmt) => {
            str +=
              " Name:" +
              cmt.userName +
              "\n Date:" +
              moment(new Date(cmt.createdDate)).format("DD-MMM-yyyy HH:mm:ss") +
              "\n Comments: " +
              cmt.taskComment +
              "\r\n";
          });
          task["progressHistory"] = str;
        } else {
          task["progressHistory"] = null;
        }

        if (task.isClosed === false) {
          task.isClosed = "Open";
        } else {
          task.isClosed = "Closed";
        }
        if (task.isApproved === false) {
          task.isApproved = "No";
        } else {
          task.isApproved = "Yes";
        }
      });
    await this.createDynamicDropdowns(response.tasks);
    this.setState({
      AttachmentLoadingFlagForAction: true,
      taskList: response.tasks,
    });

    let taskDataUri = await this.exportTask();
    var stringLength = taskDataUri.length;
    var sizeInBytes = 4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
    var sizeInKb = sizeInBytes / 1000;
    var taskAttachments = [];
    let fileName = response.name ? response.name.replace(" ", "_") : "Tasks";
    taskAttachments.push({
      filename: fileName + ".xlsx",
      size: Math.round(sizeInKb),
      fileData: taskDataUri,
    });

    this.setState({
      taskList: [],
      mailDataBytes: [...this.state.mailDataBytes, ...taskAttachments],
    });
  };

  getTaskActionsAttachments = async (response) => {
    response.taskActions &&
      response.taskActions.map((task) => {
        if (task.originalCompletionDate) {
          task.originalCompletionDate = new Date(task.originalCompletionDate); //riskReg.originalCompletionDate? moment(new Date(riskReg.originalCompletionDate)).format("DD-MMM-YYYY"):null;
        }
        if (task.projectedCompletionDate) {
          task.projectedCompletionDate = new Date(task.projectedCompletionDate); //riskReg.projectedCompletionDate? moment(new Date(riskReg.projectedCompletionDate)).format("DD-MMM-YYYY"):null;
        }
        if (task.actualCompletionDate) {
          task.actualCompletionDate = new Date(task.actualCompletionDate); //riskReg.actualCompletionDate? moment(new Date(riskReg.actualCompletionDate)).format("DD-MMM-YYYY"):null;
        }
        if (task.proximityAlertDate) {
          task.proximityAlertDate = new Date(task.proximityAlertDate); //riskReg.proximityAlertDate? moment(new Date(riskReg.proximityAlertDate)).format("DD-MMM-YYYY"):null;
        }
        if (task.updatedDate) {
          var time = moment(task.updatedDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let updatedDate = time;
          task.updatedDate = task.updatedDate ? new Date(updatedDate) : "";
        }
        if (task.createdDate) {
          let time = moment(task.createdDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let createdDate = time;
          task.createdDate = task.createdDate ? new Date(createdDate) : "";
        }
        if (task.closedDate) {
          let time = moment(task.closedDate).toDate();
          time.setHours(0);
          time.setMinutes(0);
          time.setSeconds(0);
          time.setMilliseconds(0);
          let closedDate = time;
          task.closedDate = task.closedDate ? new Date(closedDate) : "";
        }
        let str = "";
        if (task.actionProgressComments) {
          task.actionProgressComments.map((cmt) => {
            str +=
              " Name:" +
              cmt.userName +
              "\n Date:" +
              moment(new Date(cmt.createdDate)).format("DD-MMM-yyyy HH:mm:ss") +
              "\n Comments: " +
              cmt.taskActionComment +
              "\r\n";
          });
          task["progressHistory"] = str;
        } else {
          task["progressHistory"] = null;
        }
        if (task.isClosed === false) {
          task.isClosed = "Open";
        } else {
          task.isClosed = "Closed";
        }
        if (task.isApproved === false) {
          task.isApproved = "No";
        } else {
          task.isApproved = "Yes";
        }
      });

    await this.createDynamicDropdowns(response.taskActions);
    this.setState({
      AttachmentLoadingFlagForAction: true,
      taskActionList: response.taskActions,
    });

    let taskActionsDataUri = await this.exportTaskActions();
    var stringLength = taskActionsDataUri.length;
    var sizeInBytes = 4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
    var sizeInKb = sizeInBytes / 1000;
    var taskActionsAttachments = [];
    let fileName = response.name
      ? response.name.replace(" ", "_")
      : "Activities";
    taskActionsAttachments.push({
      filename: fileName + ".xlsx",
      size: Math.round(sizeInKb),
      fileData: taskActionsDataUri,
    });

    this.setState({
      taskList: [],
      mailDataBytes: [...this.state.mailDataBytes, ...taskActionsAttachments],
    });
  };

  getRiskDataset = async (WidgetId) => {
    try {
      this.setState({ ...this.state, loader: true });
      var req = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        ViewId: WidgetId,
      };
      var response = await Api.getByViewId(req);
      if (response.status === 200) {
        response.riskRegister.map((riskReg) => {
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (riskReg.createdDate) {
            riskReg.createdDate = new Date(riskReg.createdDate);
          }
          riskReg.updatedDate = riskReg.updatedDate
            ? new Date(riskReg.updatedDate)
            : "";
          if (riskReg.riskTypeNames) {
            riskReg["riskTypeNames"] = riskReg.riskTypeNames.toString();
          }
        });
        var temp = response.isPrimeWorkstreams;
        this.setState({
          ...this.state,
          isRiskValid: temp,
        });
        let impactMaster = [];
        if (response.riskRegister && response.riskRegister.length > 0) {
          impactMaster = response.riskRegister[0].impactResponse;
        }
        this.setState({ ...this.state, impactMaster: impactMaster });
        await this.createDynamicDropdowns(response.riskRegister);
        await this.createDynamicCols(response.riskRegister);
        this.setState({
          ...this.state,
          riskList: response.riskRegister,
          showSecion: "viewrisks",
          loader: false,
        });
      } else {
        this.setState({
          ...this.state,
          riskList: [],
          loader: false,
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        riskList: [],
        loader: false,
      });
    }
  };

  getActionDataByViewId = async (ViewId) => {
    try {
      const requestParams = {
        ViewId: ViewId,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getMitigationFromView(requestParams);
      if (response.status === 200) {
        response.riskMitigationResponse.map((riskReg) => {
          if (riskReg.createdDate) {
            var time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          }

          riskReg.actualCompletionDate = riskReg.actualCompletionDate
            ? new Date(riskReg.actualCompletionDate)
            : "";
          riskReg.originalCompletionDate = riskReg.originalCompletionDate
            ? new Date(riskReg.originalCompletionDate)
            : "";
          riskReg.projectedCompletionDate = riskReg.projectedCompletionDate
            ? new Date(riskReg.projectedCompletionDate)
            : "";

          riskReg["spi"] = riskReg.spi ? parseInt(riskReg.spi) : 0;
          riskReg["percentageCompletion"] = parseInt(
            riskReg.percentageCompletion
          );
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (riskReg.riskTypeNames) {
            riskReg["riskTypeNames"] = riskReg.riskTypeNames.toString();
          }
        });
        this.setState({
          ...this.state,
          loader: false,
          mitigationData: response.riskMitigationResponse,
          showSecion: "viewActions",
        });
        this.refs.child.refreshData(response.riskMitigationResponse);
      } else {
        this.setState({
          ...this.state,
          loader: false,
          mitigationData: [],
          showSecion: "viewActions",
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  //CF
  createDynamicDropdowns = async (products) => {
    try {
      let dropdownColumn = [];
      products &&
        products.map((res, i) => {
          res.customFields &&
            res.customFields.map((item, j) => {
              if (dropdownColumn.length > 0) {
                if (
                  !dropdownColumn.find((cf) => cf.fieldName == item.fieldName)
                ) {
                  dropdownColumn.push({
                    fieldName: item.fieldName,
                    data: this.getCustomFieldMasterData(item.fieldName),
                    inputType: this.getInputType(item.fieldName),
                  });
                }
              } else {
                dropdownColumn.push({
                  fieldName: item.fieldName,
                  data: this.getCustomFieldMasterData(item.fieldName),
                  inputType: this.getInputType(item.fieldName),
                });
              }
            });
        });

      if (dropdownColumn.length > 0) {
        products.map((res) => {
          dropdownColumn.map((col) => {
            let temp = res.customFields.find(
              (item) => item.fieldName === col.fieldName
            );
            if (temp) {
              if (temp.inputType === "Multi Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Single Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Free Text") {
                let val = temp.multiText ? temp.multiText : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Numeric") {
                let val = temp.multiText ? parseInt(temp.multiText) : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Date") {
                let val = temp.multiText ? new Date(temp.multiText) : "";
                res[col.fieldName] = val;
              }
            } else {
              res[col.fieldName] = "";
            }
          });
        });
      }
      let columnsToShow = [];
      if (dropdownColumn.length > 0) {
        columnsToShow = dropdownColumn.map((item) => (
          <Column
            field={item.fieldName}
            title={item.fieldName}
            width="150px"
            cell={(props) =>
              this.viewMultiselectColsCustomDropdown(props, item)
            }
          />
        ));
      }
      this.setState({ ...this.state, dropdownColumns: columnsToShow });
    } catch (err) {}
  };

  createDynamicDropdownsForAction = async (products) => {
    try {
      let dropdownColumn = [];
      products &&
        products.map((res, i) => {
          res.customFields &&
            res.customFields.map((item, j) => {
              if (dropdownColumn.length > 0) {
                if (
                  !dropdownColumn.find((cf) => cf.fieldName == item.fieldName)
                ) {
                  dropdownColumn.push({
                    fieldName: item.fieldName,
                    data: this.getCustomFieldMasterData(item.fieldName),
                    inputType: this.getInputType(item.fieldName),
                  });
                }
              } else {
                dropdownColumn.push({
                  fieldName: item.fieldName,
                  data: this.getCustomFieldMasterData(item.fieldName),
                  inputType: this.getInputType(item.fieldName),
                });
              }
            });
        });

      if (dropdownColumn.length > 0) {
        products.map((res) => {
          dropdownColumn.map((col) => {
            let temp = res.customFields.find(
              (item) => item.fieldName === col.fieldName
            );
            if (temp) {
              if (temp.inputType === "Multi Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Single Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Free Text") {
                let val = temp.multiText ? temp.multiText : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Numeric") {
                let val = temp.multiText ? parseInt(temp.multiText) : "";
                res[col.fieldName] = val;
              } else if (temp.inputType === "Date") {
                let val = temp.multiText ? new Date(temp.multiText) : "";
                res[col.fieldName] = val;
              }
            } else {
              res[col.fieldName] = "";
            }
          });
        });
      }
      let columnsToShow = [];
      if (dropdownColumn.length > 0) {
        columnsToShow = dropdownColumn.map((item) => (
          <Column
            field={item.fieldName}
            title={item.fieldName}
            width="150px"
            cell={(props) =>
              this.viewMultiselectColsCustomDropdown(props, item)
            }
          />
        ));
      }
      this.setState({ ...this.state, dropdownColumns: columnsToShow });
    } catch (err) {}
  };

  getInputType = (fieldName) => {
    try {
      let arr = this.state.customFieldsmaster.find(
        (item) => item.fieldName == fieldName
      );
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.log(err);
    }
  };

  viewMultiselectColsCustomDropdown = (event, cfObj) => {
    let data = cfObj.data;
    let value = event.dataItem[event.field];

    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <td
          title={
            value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""
          }
        >
          {value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <td title={value ? moment(value).format("DD-MMM-YYYY") : ""}>
          {value ? moment(value).format("DD-MMM-YYYY") : ""}
        </td>
      );
    } else {
      return <td></td>;
    }
  };

  getCustomFieldMasterData = (fieldName) => {
    try {
      let arr = this.state.customFieldsmaster.filter(
        (item) => item.fieldName == fieldName
      );
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: false,
            hashValue: item.hashValue, //this.convertStrToHash(item),
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };

  stringToHashForCF(stringArr, data) {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name == item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name == stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    return hashArr.toString();
  }

  createDynamicCols = async (products) => {
    try {
      let impactColumn = [];
      if (products) {
        products.map((res, i) => {
          if (res.impactResponse) {
            res.impactResponse.map((item, j) => {
              if (impactColumn.length > 0) {
                if (
                  !impactColumn.find((cf) => cf.fieldName == item.fieldName)
                ) {
                  impactColumn.push({
                    fieldName: item.name + "_" + item.type,
                    impactType: item.impactType,
                  });
                }
              } else {
                impactColumn.push({
                  fieldName: item.name + "_" + item.type,
                  impactType: item.impactType,
                });
              }
            });
          }
        });
      }
      // impactColumn.sort();
      // impactColumn.reverse();
      impactColumn = impactColumn.filter(
        (ele, ind) =>
          ind ===
          impactColumn.findIndex(
            (elem) =>
              elem.fieldName === ele.fieldName &&
              elem.impactType === ele.impactType
          )
      );

      if (impactColumn.length > 0) {
        products.map((res) => {
          impactColumn.map((col) => {
            if (col.impactType == "Qualitative") {
              let temp = res.impactResponse.find(
                (item) => item.name + "_" + item.type === col.fieldName
              );
              if (temp) {
                res[col.fieldName] =
                  temp.type == "Post" ? temp.postQvalue : temp.qValue;
              } else {
                res[col.fieldName] = 0;
              }
            } else {
              let temp = res.impactResponse.find(
                (item) => item.name + "_" + item.type === col.fieldName
              );
              if (temp) {
                res[col.fieldName] =
                  temp.type == "Post" ? temp.postImpactValue : temp.value;
              } else {
                res[col.fieldName] = 0;
              }
            }
          });
        });
      }

      let columnsToShow = [];
      console.log("impactColumn", impactColumn);
      if (impactColumn.length > 0) {
        columnsToShow = impactColumn.map((item) => (
          <Column
            field={item.fieldName}
            title={this.getImpactUnit(item)}
            width="100px"
            editable={false}
            cell={(props) => this.getImpactCellComponent(props, item)}
            filter={"numeric"}
          />
        ));
      }
      this.setState({ ...this.state, impactColumns: columnsToShow });
    } catch (err) {
      console.log(err);
    }
  };

  getImpactCellComponent = (props, impact) => {
    if (impact.impactType == "Qualitative") {
      return (
        <QualitativeImpactEditComponent
          {...props}
          onEditCell={this.onEditCell}
        />
      );
    } else {
      return <ImpactEditComponent {...props} onEditCell={this.onEditCell} />;
    }
  };

  getImpactUnit = (impact) => {
    if (impact.impactType == "Qualitative") {
      var impactTemp = this.state.impactMaster.find(
        (item) => item.name + "_" + item.type == impact.fieldName
      );
      var res = impact.fieldName;
      if (impactTemp && impactTemp.name) {
        res = impactTemp.name + " / " + " (" + impactTemp.type + ")";
      }
      return res;
    } else {
      var impactTemp = this.state.impactMaster.find(
        (item) => item.name + "_" + item.type == impact.fieldName
      );
      var res = impact.fieldName;
      if (impactTemp && impactTemp.name) {
        res =
          impactTemp.name +
          " / " +
          impactTemp.units +
          " (" +
          impactTemp.type +
          ")";
      }
      return res;
    }
  };

  createDynamicColsForAction = async (products) => {
    let impactMaster = [];
    if (products && products.length > 0) {
      impactMaster = products[0].impactResponse;
    }

    let impactColumn = [];

    products.map((res, i) => {
      if (res.impactResponse) {
        res.impactResponse.map((item, j) => {
          if (impactColumn.length > 0) {
            if (!impactColumn.includes(item.name)) {
              impactColumn.push(item.name);
            }
          } else {
            impactColumn.push(item.name);
          }
        });
      }

      if (res.createdDate) {
        var time = moment(res.createdDate).toDate();
        time.setHours(0);
        time.setMinutes(0);
        time.setSeconds(0);
        time.setMilliseconds(0);
        let createdDate = time;
        res.createdDate = res.createdDate ? new Date(createdDate) : "";
      }
      if (res.updatedDate) {
        var time = moment(res.updatedDate).toDate();
        time.setHours(0);
        time.setMinutes(0);
        time.setSeconds(0);
        time.setMilliseconds(0);
        let updatedDate = time;
        res.updatedDate = res.updatedDate ? new Date(updatedDate) : "";
      }
      if (res.actualCompletionDate) {
        res.actualCompletionDate = new Date(res.actualCompletionDate);
      }
      if (res.originalCompletionDate) {
        res.originalCompletionDate = new Date(res.originalCompletionDate);
      }
      if (res.projectedCompletionDate) {
        res.projectedCompletionDate = new Date(res.projectedCompletionDate);
      }
      if (res.proximityDate) {
        res.proximityDate = new Date(res.proximityDate);
      }
      if (res.riskTypeNames) {
        res["riskTypeNames"] = res.riskTypeNames.toString();
      }
      let str = "";
      if (res.actionImpactComments) {
        res.actionImpactComments.map((cmt) => {
          str +=
            " Name:" +
            cmt.userName +
            "\n Date:" +
            moment(new Date(cmt.createdDate)).format("DD-MMM-yyyy HH:mm:ss") +
            "\n Comments: " +
            cmt.actionComment +
            "\r\n";
        });
        res["progressHistory"] = str;
      } else {
        res["progressHistory"] = null;
      }
      res.approved = res.approved ? "Yes" : "No";
      res.isOpen = res.isOpen ? "Open" : "Closed";
    });
    if (impactColumn.length > 0) {
      products.map((res) => {
        impactColumn.map((col) => {
          let temp = res.impactResponse.find((item) => item.name === col);
          if (temp) {
            res[col] =
              temp.impactType == "Quantitative" ? temp.value : temp.qValue;
          } else {
            res[col] = undefined;
          }
        });
      });
    }
    let columnsToShow = [];
    if (impactColumn.length > 0) {
      columnsToShow = impactColumn.map((item) => (
        <Column
          field={item}
          title={"Change in " + this.getImpactUnitAction(item, impactMaster)}
          width="100px"
          editable={false}
          filter={"numeric"}
          cell={(props) => (
            <CurrencyFormat {...props} onEditCell={this.onEditCell} />
          )}
        />
      ));
    }
    this.setState({ ...this.state, impactColumnsExport: columnsToShow });
  };

  getImpactUnitAction = (impact, impactMaster) => {
    var res = impact;
    var impactTemp = impactMaster.find((item) => item.name == impact);

    if (impactTemp && impactTemp.name) {
      let unit = impactTemp.units ? " / " + impactTemp.units : "";
      res = impactTemp.name + " " + unit;
    }
    return res;
  };

  getCustomField = async () => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };

      let response = await Api.getCustomField(request);
      if (response.status == 200) {
        this.setState({
          ...this.state,
          customFieldsmaster: [...response.customFields],
        });
      }
    } catch (err) {
      console.error("Exception:", err);
    }
  };

  getWidgetBycart = async (Widget) => {
    try {
      this.setState({ ...this.state, loader: true, showSecion: "viewreports",chartData: [] });
      var req = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        WidgetId: Widget.widgetId,
      };
      var response = await Api.GetSinglewidget(req);
      if (response.status === 200) {
        this.setState({
          loader: false,
          chartData: response.chartData,
        });
        //console.clear();
      } else {
        this.setState({
          loader: false,
          chartData: [],
        });
        //console.clear();
      }
    } catch (error) {
      console.error(error);
      this.setState({
        loader: false,
        chartData: [],
      });
    }
  };

  toggleTemplate(templateId) {
    if (this.state.viewTemplate) {
      this.setState({
        viewTemplate: !this.state.viewTemplate,
        viewTemplateId: templateId,
      });
    } else {
      this.setState({
        viewTemplate: !this.state.viewTemplate,
        viewTemplateId: 0,
      });
    }
  }

  GetCartList = async () => {
    try {
      this.setState({ ...this.state, loader: true });

      var req = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      var response = await Api.GetCartList(req);
      if (response.status === 200) {
        this.setState({
          templateList: response.templateList,
          loader: false,
        });
        //console.clear();
      } else {
        this.setState({
          templateList: [],
          loader: false,
        });
        //console.clear();
      }
    } catch (error) {
      console.error(error);
      this.setState({
        templateList: [],
        loader: false,
      });
    }
  };

  DeleteTemplate = async (id) => {
    try {
      this.setState({ ...this.state, loader: true });

      var req = {
        Id: id,
        DeletedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DeletedDate: new Date(),
      };
      var response = await Api.DeleteTemplate(req);
      if (response.status === 200) {
        toastr.success(response.message);
        this.GetCartList();
        this.setState({
          loader: false,
        });
        //console.clear();
      } else {
        this.setState({
          loader: false,
        });
        toastr.error(response.message);
        //console.clear();
      }
    } catch (error) {
      console.error(error);
      this.setState({
        templateList: [],
        loader: false,
      });
    }
  };

  DeleteCart = async (id) => {
    try {
      this.setState({ ...this.state, loader: true });

      var req = {
        Id: id,
        DeletedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DeletedDate: new Date(),
      };
      var response = await Api.DeleteCart(req);
      if (response.status === 200) {
        toastr.success(response.message);
        this.GetCartList();
        this.setState({
          loader: false,
        });
        //console.clear();
      } else {
        this.setState({
          loader: false,
        });
        toastr.error(response.message);
        //console.clear();
      }
    } catch (error) {
      console.error(error);
      this.setState({
        templateList: [],
        loader: false,
      });
    }
  };
  onEditCell = () => {};

  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };

  mitigationFilterQuery = (query) => {};
  changeLineChartWidth = () => {};
  refreshTextWidget = () => {};
  getChartContainer = (chart) => {
    var componant = <div></div>;
    if (chart.widgetType === "LINE_CHART") {
      componant = (
        <LineChartContainer
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
        />
      );
    } else if (chart.widgetType === "BAR_CHART") {
      componant = (
        <BarChartContainer
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
        />
      );
    } else if (chart.widgetType === "PIE_CHART") {
      componant = (
        <PieChartContainer
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
          overAllDownlad={true}
        />
      );
    } else if (chart.widgetType === "BURN_DOWN_CHART") {
      componant = (
        <BurnDownChartContainer
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
        />
      );
    } else if (chart.widgetType === "HEAT_MAP" && chart.timeStamp === false) {
      componant = (
        <HeatMapChartContainer
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
        />
      );
    } else if (chart.widgetType === "HEAT_MAP" && chart.timeStamp === true) {
      componant = (
        <HeatMapTimeStamp
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
        />
      );
    } else if (chart.widgetType == "DATA" && chart.isActionWidget) {
      componant = (
        <DataReportForAction
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={true}
          customFieldsmaster={this.state.customFieldsmaster}
        />
      );
    } else if (chart.widgetType == "DATA" && !chart.isActionWidget) {
      componant = (
        <DataReportForRisk
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={true}
          customFieldsmaster={this.state.customFieldsmaster}
          HeatMapConfigDataOpportunity={this.state.HeatMapConfigDataOpportunity}
          HeatMapConfigDataThreat={this.state.HeatMapConfigDataThreat}
          dynamicHeatmapProbabilityRange={
            this.state.dynamicHeatmapProbabilityRange
          }
        />
      );
    } else if (chart.widgetType == "TRENDING_CHART") {
      componant = (
        <TrendingLineChart
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
        />
      );
    }
    //New
    else if (chart.widgetType === "DOUGHNUT_CHART") {
      componant = (
        <Histogramwidget
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          flag={false}
          expandIcon={false}
          viewDataSetIcon={false}
        />
      );
    } else if (chart.widgetType === "KPI") {
      componant = (
        <TileChart
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          refreshTextWidget={this.refreshTextWidget}
          flag={false}
          expandIcon={false}
        />
      );
    } else if (chart.widgetType === "TEXT_WIDGET") {
      componant = (
        <RichTextChart
          chartInputs={chart}
          changeLineChartWidth={this.changeLineChartWidth}
          refreshTextWidget={this.refreshTextWidget}
          flag={false}
          expandIcon={false}
        />
      );
    }
    return componant;
  };

  getEmailSuggestion = async () => {
    try {
      var response = await Api.getEmailSuggestion();
      if (response) {
        this.setState({
          emailSuggestion: response,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  sendMailToUser = async () => {
    try {
      var req = {
        emailTo: this.state.emailTo,
        emailCC: this.state.emailCC,
        Subject: this.state.Subject,
        Body: this.state.Body,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        fileDatas: this.state.mailDataBytes,
      };
      this.setState({
        loader: true,
      });
      var response = await Api.CartSendMail(req);
      if (response.status === 200) {
        toastr.success(response.message);

        this.setState({
          loader: false,
          Subject: "",
          Body: "",
          Email: "",
          mailDataBytes: [],
          showSecion: undefined,
        });
        //console.clear();
      } else {
        this.setState({
          loader: false,
        });
        toastr.error(response.message);
        //console.clear();
      }
    } catch (err) {
      console.log(err);
      this.setState({
        loader: false,
      });
    }
  };

  exportAction = async () => {
    // this._exporter.current.save();
    let dd = await this._exporterAction.current.toDataURL().then((dataURL) => {
      const base64 = dataURL.split(";base64,")[1];
      return base64;
    });
    return dd;
  };

  exportRisk = async () => {
    // this._exporter.current.save();
    let dd = await this._exporterRisk.current.toDataURL().then((dataURL) => {
      const base64 = dataURL.split(";base64,")[1];
      return base64;
    });
    return dd;
  };

  exportTask = async () => {
    let dd = await this._exporterTask.current.toDataURL().then((dataURL) => {
      const base64 = dataURL.split(";base64,")[1];
      return base64;
    });
    return dd;
  };

  exportTaskActions = async () => {
    let dd = await this._exporterTaskAction.current
      .toDataURL()
      .then((dataURL) => {
        const base64 = dataURL.split(";base64,")[1];
        return base64;
      });
    return dd;
  };

  addAdditionalFiles = (e) => {
    try {
      console.log(e);
      if (e.target.files.length > 0) {
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          console.log(reader.result);
          let additionalAttachments = [];
          additionalAttachments.push({
            filename: file.name,
            size: Math.round(file.size / 1000),
            fileData: reader.result.split(";base64,")[1],
          });
          this.setState({
            mailDataBytes: [
              ...this.state.mailDataBytes,
              ...additionalAttachments,
            ],
          });
        };
      }
    } catch (err) {
      console.log(err);
    }
  };
  removeAttachment = (index) => {
    try {
      // let array=
      this.state.mailDataBytes.splice(index, 1);
      this.setState({
        mailDataBytes: this.state.mailDataBytes,
      });
    } catch (err) {
      console.log(err);
    }
  };
  onTagsChangeTo = (event, values) => {
    this.setState(
      {
        emailTo: values,
      },
      () => {
        // This will output an array of objects
        // given by Autocompelte options property.
        console.log(this.state.emailTo);
      }
    );
  };

  onTagsChangeCC = (event, values) => {
    this.setState(
      {
        emailCC: values,
      },
      () => {
        // This will output an array of objects
        // given by Autocompelte options property.
        console.log(this.state.emailCC);
      }
    );
  };

  openEmailTemplatePopup = (flag, data) => {
    if (flag === "ADD") {
      this.setState({
        showEmailTemplate: true,
        templateFlag: flag,
        description: "",
        name: "",
      });
    } else {
      this.setState({
        showEmailTemplate: true,
        description: data.description,
        name: data.name,
        templateId: data.templateId,
        templateFlag: flag,
      });
    }
  };
  closeAddTemplate = () => {
    this.setState({ showEmailTemplate: false });
  };

  saveTemplate = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      var req = {
        Name: this.state.name.trim(),
        description: this.state.description,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      var response = await Api.AddTemplate(req);
      if (response.status === 200) {
        toastr.success(response.message);
        this.setState({ ...this.state, loader: false });

        this.closeAddTemplate();
        this.GetCartList();
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  UpdateTemplate = async () => {
    try {
      this.setState({ ...this.state, loader: true });

      var req = {
        id: this.state.templateId,
        Name: this.state.name.trim(),
        description: this.state.description,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      var response = await Api.UpdateTemplate(req);
      if (response.status === 200) {
        toastr.success(response.message);
        this.setState({ ...this.state, loader: false });
        this.closeAddTemplate();
        this.GetCartList();
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };
  render() {
    let isPrime = secureLocalStorage.getItem("isPrime") == false ? false : true;

    return (
      <div className="cartWrapper">
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}

        {this.state.emailloader ? (
          <span className="MatTableSpinner">
            <MuiThemeProvider theme={theme}>
              <LinearProgress color="secondary" />
            </MuiThemeProvider>
            <span>Attaching Files... </span>
          </span>
        ) : null}

        <div className="cartInnerWrapper">
          <div className="cartSidebar">
            <h5>
              Templates &nbsp;&nbsp;
              <a
                href="#"
                onClick={() => this.openEmailTemplatePopup("ADD", {})}
              >
                <img src={Images.ADDGREENICON} width="10" alt="" />
              </a>
            </h5>
            {this.state.templateList &&
              this.state.templateList.map((data) => {
                return (
                  <div className="templateList">
                    <div className="templateHead">
                      <h6 title={data.description}>{data.name}</h6>
                      <ul>
                        <li>
                          <a
                            class="iconR"
                            onClick={() =>
                              this.openEmailTemplatePopup("EDIT", data)
                            }
                          >
                            <img
                              src={Images.EDITICON}
                              className="stateIcon"
                              width="10"
                              alt=""
                            />
                          </a>
                        </li>
                        <li>
                          <a onClick={() => this.sendEmail(data)} href="#">
                            <img src={Images.EMAIL} width="14" alt="email" />
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => this.DeleteTemplate(data.templateId)}
                          >
                            <img src={Images.TRASH} width="13" alt="delete" />
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => this.toggleTemplate(data.templateId)}
                            className={
                              this.state.viewTemplateId === data.templateId
                                ? "active"
                                : ""
                            }
                          >
                            <img src={Images.ARROW} width="13" alt="Arrow" />
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div
                      className={
                        this.state.viewTemplateId === data.templateId
                          ? "subLists show"
                          : "subLists"
                      }
                    >
                      <div className="tempSubList">
                        <h5>Reports</h5>
                        {data.widgetList &&
                          data.widgetList.map((widData) => (
                            <div className="templateHead">
                              <h6 title={widData.description}>
                                {widData.name}
                              </h6>
                              <ul>
                                <li>
                                  <a
                                    onClick={() => this.viewReports(widData)}
                                    href="#"
                                  >
                                    <img
                                      src={Images.VIEW}
                                      width="14"
                                      alt="View"
                                    />
                                  </a>
                                </li>
                                <li>
                                  <a
                                    onClick={() =>
                                      this.DeleteCart(widData.cartId)
                                    }
                                  >
                                    <img
                                      src={Images.TRASH}
                                      width="13"
                                      alt="delete"
                                    />
                                  </a>
                                </li>
                              </ul>
                            </div>
                          ))}
                      </div>

                      <div className="tempSubList">
                        <h5>Risk Datasets</h5>
                        {data.riskDatasetList &&
                          data.riskDatasetList.map((riskdata) => (
                            <div className="templateHead">
                              <h6 title={riskdata.description}>
                                {riskdata.name}
                              </h6>
                              <ul>
                                <li>
                                  <a
                                    onClick={() =>
                                      this.viewRisks(riskdata.riskDatasetId)
                                    }
                                  >
                                    <img
                                      src={Images.VIEW}
                                      width="14"
                                      alt="View"
                                    />
                                  </a>
                                </li>
                                <li>
                                  <a
                                    onClick={() =>
                                      this.DeleteCart(riskdata.cartId)
                                    }
                                  >
                                    <img
                                      src={Images.TRASH}
                                      width="13"
                                      alt="delete"
                                    />
                                  </a>
                                </li>
                              </ul>
                            </div>
                          ))}
                      </div>

                      <div className="tempSubList">
                        <h5>Action Datasets</h5>
                        {data.actionDatasetList &&
                          data.actionDatasetList.map((actionData) => (
                            <div className="templateHead">
                              <h6 title={actionData.description}>
                                {" "}
                                {actionData.name}
                              </h6>
                              <ul>
                                <li>
                                  <a
                                    onClick={() =>
                                      this.viewAction(
                                        actionData.actionDatasetId
                                      )
                                    }
                                  >
                                    <img
                                      src={Images.VIEW}
                                      width="14"
                                      alt="View"
                                    />
                                  </a>
                                </li>
                                <li>
                                  <a
                                    onClick={() =>
                                      this.DeleteCart(actionData.cartId)
                                    }
                                  >
                                    <img
                                      src={Images.TRASH}
                                      width="13"
                                      alt="delete"
                                    />
                                  </a>
                                </li>
                              </ul>
                            </div>
                          ))}
                      </div>
                      {secureLocalStorage.getItem("isTasksModuleEnabled") ===
                      true ? (
                        <div className="tempSubList">
                          <h5>Tasks Datasets</h5>
                          {data.taskDatasetList &&
                            data.taskDatasetList.map((taskData) => (
                              <div className="templateHead">
                                <h6 title={taskData.description}>
                                  {" "}
                                  {taskData.name}
                                </h6>
                                <ul>
                                  <li>
                                    <a
                                      onClick={() =>
                                        this.viewTask(taskData.taskDatasetId)
                                      }
                                    >
                                      <img
                                        src={Images.VIEW}
                                        width="14"
                                        alt="View"
                                      />
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      onClick={() =>
                                        this.DeleteCart(taskData.cartId)
                                      }
                                    >
                                      <img
                                        src={Images.TRASH}
                                        width="13"
                                        alt="delete"
                                      />
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            ))}
                        </div>
                      ) : (
                        ""
                      )}

                      {secureLocalStorage.getItem("isTasksModuleEnabled") ===
                      true ? (
                        <div className="tempSubList">
                          <h5>Activities Datasets</h5>
                          {data.taskActionDatasetList &&
                            data.taskActionDatasetList.map((activityData) => (
                              <div className="templateHead">
                                <h6 title={activityData.description}>
                                  {" "}
                                  {activityData.name}
                                </h6>
                                <ul>
                                  <li>
                                    <a
                                      onClick={() =>
                                        this.viewTaskAction(
                                          activityData.taskActionDatasetId
                                        )
                                      }
                                    >
                                      <img
                                        src={Images.VIEW}
                                        width="14"
                                        alt="View"
                                      />
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      onClick={() =>
                                        this.DeleteCart(activityData.cartId)
                                      }
                                    >
                                      <img
                                        src={Images.TRASH}
                                        width="13"
                                        alt="delete"
                                      />
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            ))}
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="tempSubList">
                        <h5>Workstream - Risk</h5>
                        {data.workstreamList &&
                          data.workstreamList.map((item) => (
                            <div className="templateHead">
                              <h6 title={item.description}> {item.name}</h6>
                              <ul>
                                <li>
                                  <a
                                    onClick={() =>
                                      this.viewWorkstream(item.workstreamId)
                                    }
                                  >
                                    <img
                                      src={Images.VIEW}
                                      width="14"
                                      alt="View"
                                    />
                                  </a>
                                </li>
                                <li>
                                  <a
                                    onClick={() => this.DeleteCart(item.cartId)}
                                  >
                                    <img
                                      src={Images.TRASH}
                                      width="13"
                                      alt="delete"
                                    />
                                  </a>
                                </li>
                              </ul>
                            </div>
                          ))}
                      </div>
                      {secureLocalStorage.getItem("isTasksModuleEnabled") ===
                      true ? (
                        <div className="tempSubList">
                          <h5>Workstream - Task</h5>
                          {data.taskWorkstreamList &&
                            data.taskWorkstreamList.map((item) => (
                              <div className="templateHead">
                                <h6 title={item.description}> {item.name}</h6>
                                <ul>
                                  <li>
                                    <a
                                      onClick={() =>
                                        this.viewWorkstreamTask(
                                          item.workstreamId
                                        )
                                      }
                                    >
                                      <img
                                        src={Images.VIEW}
                                        width="14"
                                        alt="View"
                                      />
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      onClick={() =>
                                        this.DeleteCart(item.cartId)
                                      }
                                    >
                                      <img
                                        src={Images.TRASH}
                                        width="13"
                                        alt="delete"
                                      />
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            ))}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="mainWrapper">
            <div className="cartHeader">{/* <h3>Template</h3> */}</div>

            {this.state.showSecion === "sendemail" ? (
              <div className="sendEmailCont">
                <h3>Send Email - {this.state.currentTemplate}</h3>
                {/* <div className="formCont">
                  <div className="fieldCol">
                    <div className="fieldCont">
                      <input
                        type="text"
                        value={this.state.Email}
                        name="mailto"
                        placeholder="To"
                        onChange={(e) =>
                          this.setState({
                            Email: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div> */}

                <div className="emailField">
                  <label className="fieldLabel">To</label>
                  <Autocomplete
                    multiple
                    id="emailto"
                    autoSelect={true}
                    options={this.state.emailSuggestion.map((option) => option)}
                    freeSolo
                    // defaultValue={[top100Films[13]]}
                    onChange={this.onTagsChangeTo}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          variant="outlined"
                          label={option}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                    PaperComponent={({ children }) => (
                      <div className="paperComponent">
                        <span>{children}</span>
                      </div>
                    )}
                    renderInput={(params) => (
                      <TextField {...params} variant="filled" />
                    )}
                  />
                </div>

                <div className="emailField">
                  <label className="fieldLabel">Cc</label>
                  <Autocomplete
                    multiple
                    id="emailbcc"
                    autoSelect={true}
                    options={this.state.emailSuggestion.map((option) => option)}
                    freeSolo
                    onChange={this.onTagsChangeCC}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          variant="outlined"
                          label={option}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                    PaperComponent={({ children }) => (
                      <div className="paperComponent">
                        <span>{children}</span>
                      </div>
                    )}
                    renderInput={(params) => (
                      <TextField {...params} variant="filled" />
                    )}
                  />
                </div>

                <div className="attachHead">
                  <h5>Attachments</h5>
                </div>
                <div className="attachments">
                  <ul>
                    {this.state.mailDataBytes &&
                      this.state.mailDataBytes.map((item, index) => (
                        <li>
                          <div className="attachList">
                            <img src={Images.FILE} alt="PDF" height="24" />
                            <p>
                              {item.filename}
                              <span>{item.size}kb</span>
                            </p>
                            <a
                              onClick={() => this.removeAttachment(index)}
                              href="#"
                            >
                              <img src={Images.CLOSE} alt="Cancel" width="10" />
                            </a>
                          </div>
                        </li>
                      ))}

                    <li className="btnCont">
                      <button>
                        Add{" "}
                        <input
                          type="file"
                          // accept="application/pdf, application/xlsx"
                          onChange={(e) => this.addAdditionalFiles(e)}
                        />
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="formCont">
                  <div className="fieldCol">
                    <div className="fieldCont">
                      <input
                        type="text"
                        name="subject"
                        autoComplete="off"
                        value={this.state.Subject}
                        placeholder="Subject"
                        onChange={(e) =>
                          this.setState({
                            Subject: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="fieldCol">
                    <div className="fieldCont">
                      <textarea
                        placeholder="Message"
                        name="message"
                        autoComplete="off"
                        value={this.state.Body}
                        onChange={(e) =>
                          this.setState({
                            Body: e.target.value,
                          })
                        }
                      >
                        {" "}
                      </textarea>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="btnGroup ml-auto">
                    <button
                      className="btnPrimary"
                      type="button"
                      disabled={
                        !this.state.emailTo || this.state.emailTo.length <= 0
                      }
                      onClick={() => this.sendMailToUser()}
                    >
                      Send
                    </button>
                    <button
                      className="btnCancel"
                      type="button"
                      onClick={() => this.discardMail()}
                    >
                      Discard
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {this.state.showSecion === "viewrisks" ? (
              <div className="dataSetCont" id="rw-tab-header">
                <h4>Risk Dataset</h4>
                <div
                  className="tblCont riskRegister dataGrids riskRegTable"
                  id="primedataset"
                >
                  <Grid
                    style={{ minHeight: "100px" }}
                    // data={process(this.state.riskList, this.state.dataState)}
                    data={this.state.riskList.slice(
                      this.state.skip,
                      this.state.take + this.state.skip
                    )}
                    sortable={true}
                    pageable={true}
                    reorderable
                    resizable
                    skip={this.state.skip}
                    take={this.state.take}
                    total={this.state.riskList.length}
                    onPageChange={this.pageChange}
                  >
                    <Column
                      field="name"
                      title="Risk"
                      width="80px"
                      editable={false}
                      cell={(props) => (
                        <RiskDescriptionCell
                          {...props}
                          onEditCell={this.onEditCell}
                        />
                      )}
                    />

                    <Column field="number" title="Risk Number" width="100px" />
                    <Column
                      field="createdDate"
                      width="100px"
                      title="Created Date"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                      editable={false}
                    />
                    <Column
                      field="createdByName"
                      width="100px"
                      title="Created By"
                      editable={false}
                    />
                    <Column
                      locked={true}
                      field="riskTitle"
                      title="Risk Title*"
                      width="150px"
                    />
                    <Column
                      field="isOpportunity"
                      title="T/O"
                      width="60px"
                      cell={(props) =>
                        props.dataItem.isOpportunity === "Threat" ? (
                          <td>{props.dataItem.isOpportunity}</td>
                        ) : (
                          <td>
                            <span className="turquoiseBlue">
                              {props.dataItem.isOpportunity}
                            </span>
                          </td>
                        )
                      }
                    />
                    <Column
                      field="riskTypeNames"
                      title="Risk Type"
                      width="150px"
                    />

                    {this.state.dropdownColumns}
                    <Column
                      field="cause"
                      title="Cause"
                      width="100px"
                      editable={false}
                      cell={(props) => (
                        <RiskCauseCell
                          {...props}
                          onEditCell={this.onEditCell}
                        />
                      )}
                    />
                    <Column
                      field="existingControl"
                      title="Existing Control"
                      width="100px"
                      editable={false}
                      cell={(props) => (
                        <ExistingControlCell
                          {...props}
                          onEditCell={this.onEditCell}
                        />
                      )}
                    />
                    <Column
                      field="frequency"
                      title="Pre-Probability (%)"
                      width="80px"
                      filter={"numeric"}
                    />
                    <Column
                      field="currentProbability"
                      title="Current Probability (%)"
                      width="80px"
                      editable={false}
                      cell={(props) => (
                        <td>
                          <span className="turquoiseBlue">
                            {props.dataItem.currentProbability}
                          </span>
                        </td>
                      )}
                    />
                    <Column
                      field="reductionProbability"
                      title="Post-Probability (%)"
                      width="75px"
                      editable={false}
                      cell={(props) => (
                        <td>
                          <span className="yellowCell">
                            {props.dataItem.reductionProbability}
                          </span>
                        </td>
                      )}
                      filter={"numeric"}
                    />

                    <Column
                      field="pre"
                      title="pre"
                      width="75px"
                      sortable={false}
                      editable={false}
                      cell={(props) => (
                        <PrePostComponenant
                          {...props}
                          onEditCell={this.onEditCell}
                          HeatMapConfigDataOpportunity={
                            this.state.HeatMapConfigDataOpportunity
                          }
                          HeatMapConfigDataThreat={
                            this.state.HeatMapConfigDataThreat
                          }
                          dynamicHeatmapProbabilityRange={
                            this.state.dynamicHeatmapProbabilityRange
                          }
                        />
                      )}
                    />
                    <Column
                      field="current"
                      title="current"
                      width="75px"
                      sortable={false}
                      editable={false}
                      cell={(props) => (
                        <PrePostComponenant
                          {...props}
                          onEditCell={this.onEditCell}
                          HeatMapConfigDataOpportunity={
                            this.state.HeatMapConfigDataOpportunity
                          }
                          HeatMapConfigDataThreat={
                            this.state.HeatMapConfigDataThreat
                          }
                          dynamicHeatmapProbabilityRange={
                            this.state.dynamicHeatmapProbabilityRange
                          }
                        />
                      )}
                    />
                    <Column
                      field="post"
                      title="post"
                      width="75px"
                      sortable={false}
                      editable={false}
                      cell={(props) => (
                        <PrePostComponenant
                          {...props}
                          onEditCell={this.onEditCell}
                          HeatMapConfigDataOpportunity={
                            this.state.HeatMapConfigDataOpportunity
                          }
                          HeatMapConfigDataThreat={
                            this.state.HeatMapConfigDataThreat
                          }
                          dynamicHeatmapProbabilityRange={
                            this.state.dynamicHeatmapProbabilityRange
                          }
                        />
                      )}
                    />
                    {/* <Column
                      field="overAll"
                      title="OverAll Impact"
                      width="100px"
                      editable={false}
                      sortable={false}
                      cell={(props) => (
                        <OverallComponenant
                          {...props}
                          onEditCell={this.onEditCell}
                        />
                      )}
                    /> */}
                    {/* New  */}

                    <Column
                      field="preRiskScore"
                      title="Risk Score (Pre)"
                      filter={"numeric"}
                      width="80px"
                      editable={false}
                    />

                    {isPrime && this.state.isRiskValid === true ? (
                      <Column
                        field="preWeightedRiskScore"
                        title="Prime Risk Score (Pre)"
                        filter={"numeric"}
                        width="80px"
                        editable={false}
                        cell={(props) => (
                          <td>
                            <span>
                              {props.dataItem.isPrimeWorkstreams &&
                              secureLocalStorage.getItem("isPrime") == true
                                ? props.dataItem.preWeightedRiskScore
                                : ""}
                            </span>
                          </td>
                        )}
                      />
                    ) : null}

                    <Column
                      field="currentRiskScore"
                      title="Risk Score (Current)"
                      filter={"numeric"}
                      width="80px"
                      editable={false}
                      cell={(props) => (
                        <td>
                          <span className="turquoiseBlue">
                            {props.dataItem.currentRiskScore}
                          </span>
                        </td>
                      )}
                    />

                    {isPrime && this.state.isRiskValid === true ? (
                      <Column
                        field="currentWeightedRiskScore"
                        title="Prime Risk Score (Current)"
                        filter={"numeric"}
                        width="80px"
                        editable={false}
                        cell={(props) => (
                          <td>
                            <span className="turquoiseBlue">
                              {props.dataItem.isPrimeWorkstreams &&
                              secureLocalStorage.getItem("isPrime") == true
                                ? props.dataItem.currentWeightedRiskScore
                                : ""}
                            </span>
                          </td>
                        )}
                      />
                    ) : null}

                    <Column
                      field="postRiskScore"
                      title="Risk Score (Post)"
                      filter={"numeric"}
                      width="80px"
                      editable={false}
                      cell={(props) => (
                        <td>
                          <span className="yellowCell">
                            {props.dataItem.postRiskScore}
                          </span>
                        </td>
                      )}
                    />

                    {isPrime && this.state.isRiskValid === true ? (
                      <Column
                        field="postWeightedRiskScore"
                        title="Prime Risk Score (Post)"
                        filter={"numeric"}
                        width="80px"
                        editable={false}
                        cell={(props) => (
                          <td>
                            <span className="yellowCell">
                              {props.dataItem.isPrimeWorkstreams &&
                              secureLocalStorage.getItem("isPrime") == true
                                ? props.dataItem.postWeightedRiskScore
                                : ""}
                            </span>
                          </td>
                        )}
                      />
                    ) : null}
                    {/* End  */}
                    {this.state.impactColumns}
                    <Column
                      field="impactComments"
                      title="Consequences"
                      width="120px"
                      editable={false}
                    />
                    <Column
                      field="proximityDate"
                      title="Proximity Date"
                      width="120px"
                      editor="date"
                      filter={"date"}
                      editable={false}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column
                      field="updatedDate"
                      title="updated Date"
                      width="100px"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column
                      field="updatedBy"
                      title="updated By"
                      width="120px"
                      editable={false}
                    />
                    <Column
                      field="owner"
                      title="Owner"
                      width="120px"
                      editable={false}
                    />
                    <Column
                      field="riskFieldsCompletion"
                      title="% of fields completed"
                      width="120px"
                      editable={false}
                    />
                    <Column
                      field="isClosed"
                      title="Status"
                      width="70px"
                      // editor="boolean"
                      editable={false}
                      cell={(props) => (
                        <StatusComponent
                          {...props}
                          onEditCell={this.onEditCell}
                        />
                      )}
                      filter={"boolean"}
                    />
                    <Column
                      field="closedDate"
                      title="Closed Date"
                      width="120px"
                      editor="date"
                      filter={"date"}
                      editable={false}
                      format="{0:dd-MMM-yyyy}"
                    />
                  </Grid>
                </div>
              </div>
            ) : (
              ""
            )}

            {this.state.showSecion === "viewActions" ? (
              <div className="dataSetCont" id="rw-tab-header">
                <h4>Action Dataset</h4>
                <div
                  className="tblCont riskRegister dataGrids riskRegTable"
                  id="primedataset"
                >
                  <MitigationView
                    {...this.props}
                    mitigationData={this.state.mitigationData}
                    customFieldsmaster={this.state.customFieldsmaster}
                    ref="child"
                  ></MitigationView>
                </div>
              </div>
            ) : (
              ""
            )}

            {this.state.showSecion === "viewTask" ||
            this.state.showSecion === "viewWorkStreamTask" ? (
              <div className="dataSetCont" id="rw-tab-header">
                <h4>
                  {this.state.showSecion === "viewTask"
                    ? "Tasks Dataset"
                    : "Workstream"}
                </h4>
                <div
                  className="tblCont riskRegister dataGrids riskRegTable"
                  id="primedataset"
                >
                  <Grid
                    style={{ minHeight: "100px" }}
                    data={this.state.taskList.slice(
                      this.state.skip,
                      this.state.take + this.state.skip
                    )}
                    {...this.state.dataState}
                    onDataStateChange={(e) =>
                      this.setState({ dataState: e.dataState })
                    }
                    sortable={true}
                    pageable={true}
                    reorderable
                    resizable
                    skip={this.state.skip}
                    take={this.state.take}
                    total={this.state.taskList.length}
                    onPageChange={this.pageChange}
                    detail={ActivitiesDetails}
                    expandField="expanded"
                    onExpandChange={this.expandChangeTask}
                  >
                    <Column
                      field="organizationUnitName"
                      title="Workstream"
                      width="200px"
                    />
                    <Column field="taskNumber" title="Task Number" width="200px" />
                    <Column field="isApproved" title="Approved" width="200px" />
                    <Column
                      field="taskTitle"
                      title="Task Title"
                      width="200px"
                    />
                    <Column
                      field="taskDescription"
                      title="Task Description"
                      width="200px"
                    />
                    <Column
                      field="cost"
                      title={
                        "Cost of Task" +
                        " (" +
                        secureLocalStorage.getItem("currency") +
                        ")"
                      }
                      width="200px"
                    />
                    <Column
                      field="effort"
                      title={"Effort" + " (Days)"}
                      filter={"numeric"}
                      width="200px"
                    />
                    <Column
                      field="percentageOnTrack"
                      title="% on Track"
                      width="200px"
                      filter={"numeric"}
                    />
                    <Column
                      field="percentageCompletion"
                      title="% Completion"
                      width="200px"
                      filter={"numeric"}
                    />
                    <Column
                      field="priorityRankingName"
                      title="Priority Ranking"
                      width="200px"
                    />

                    {this.state.dropdownColumns}
                    <Column
                      field="originalCompletionDate"
                      title="Original Completion Date"
                      width="200px"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column
                      field="projectedCompletionDate"
                      title="Projected Completion Date"
                      width="200px"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column
                      field="actualCompletionDate"
                      title="Actual Completion Date"
                      width="200px"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column
                      field="proximityAlertDate"
                      title="Proximity Alert Date"
                      width="200px"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column
                      field="delayConsequence"
                      title="Delay Consequence"
                      width="200px"
                    />
                    <Column
                      field="alertStakeHolders"
                      title="Alert Stakeholders"
                      width="200px"
                    />
                    <Column
                      field="alertDescription"
                      title="Alert Description"
                      width="200px"
                    />
                    <Column
                      field="taskOwnerName"
                      title="Task Owner"
                      width="200px"
                    />
                    <Column
                      field="createdDate"
                      title="Created Date"
                      width="200px"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column
                      field="createdByName"
                      title="Created By"
                      width="200px"
                    />
                    <Column
                      field="updatedDate"
                      title="Updated Date"
                      width="200px"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column
                      field="updatedByName"
                      title="Updated By"
                      width="200px"
                    />
                    <Column
                      field="closedDate"
                      title="Closed Date"
                      width="200px"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column field="isClosed" title="Status" width="200px" />
                  </Grid>
                </div>
              </div>
            ) : (
              ""
            )}

            {this.state.showSecion === "viewTaskAction" ? (
              <div className="dataSetCont" id="rw-tab-header">
                <h4>Activities Dataset</h4>
                <div
                  className="tblCont riskRegister dataGrids riskRegTable"
                  id="primedataset"
                >
                  <Grid
                    style={{ minHeight: "100px" }}
                    // data={process(this.state.riskList, this.state.dataState)}
                    data={this.state.taskActionList.slice(
                      this.state.skip,
                      this.state.take + this.state.skip
                    )}
                    sortable={true}
                    pageable={true}
                    reorderable
                    resizable
                    skip={this.state.skip}
                    take={this.state.take}
                    total={this.state.taskActionList.length}
                    onPageChange={this.pageChange}
                  >
                    <Column
                      field="organizationUnitName"
                      title="Workstream"
                      width="200px"
                    />
                       <Column
                      field="taskNumber"
                      title="Task Number"
                      width="200px"
                    />
                    <Column
                      field="taskTitle"
                      title="Task Title"
                      width="200px"
                    />
                    <Column
                      field="taskNumber"
                      title="Task Number"
                      width="200px"
                    />
                    <Column
                      field="taskTitle"
                      title="Task Title"
                      width="200px"
                    />
                    <Column
                      field="taskActionNumber"
                      title="Activity Number"
                      width="200px"
                    />
                    <Column field="isApproved" title="Approved" width="200px" />
                    <Column
                      field="taskActionTitle"
                      title="Activity Title"
                      width="200px"
                    />
                    <Column
                      field="taskActionDescription"
                      title="Activity Description"
                      width="200px"
                    />
                    <Column
                      field="cost"
                      title={
                        "Cost of Activity" +
                        " (" +
                        secureLocalStorage.getItem("currency") +
                        ")"
                      }
                      width="200px"
                    />
                    <Column
                      field="effort"
                      title={"Effort" + " (Days)"}
                      filter={"numeric"}
                      width="200px"
                    />
                    <Column
                      field="percentageOnTrack"
                      title="% on Track"
                      width="200px"
                      filter={"numeric"}
                    />
                    <Column
                      field="percentageCompletion"
                      title="% Completion"
                      width="200px"
                      filter={"numeric"}
                    />
                    <Column
                      field="priorityRankingName"
                      title="Priority Ranking"
                      width="200px"
                    />

                    {this.state.dropdownColumns}
                    <Column
                      field="originalCompletionDate"
                      title="Original Completion Date"
                      width="200px"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column
                      field="projectedCompletionDate"
                      title="Projected Completion Date"
                      width="200px"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column
                      field="actualCompletionDate"
                      title="Actual Completion Date"
                      width="200px"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column
                      field="proximityAlertDate"
                      title="Proximity Alert Date"
                      width="200px"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column
                      field="delayConsequence"
                      title="Delay Consequence"
                      width="200px"
                    />
                    <Column
                      field="alertStakeHolders"
                      title="Alert Stakeholders"
                      width="200px"
                    />
                    <Column
                      field="alertDescription"
                      title="Alert Description"
                      width="200px"
                    />
                    <Column
                      field="ownerName"
                      title="Activity Owner"
                      width="200px"
                    />
                    <Column
                      field="createdDate"
                      title="Created Date"
                      width="200px"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column
                      field="createdByName"
                      title="Created By"
                      width="200px"
                    />
                    <Column
                      field="updatedDate"
                      title="Updated Date"
                      width="200px"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column
                      field="updatedByName"
                      title="Updated By"
                      width="200px"
                    />
                    <Column
                      field="closedDate"
                      title="Closed Date"
                      width="200px"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column field="isClosed" title="Status" width="200px" />

                    <Column
                      field="departments"
                      title="Departments"
                      width="150px"
                    />
                    <Column
                      field="externalStatus"
                      title="External Status"
                      width="120px"
                    />
                    <Column
                      field="weeklyReport"
                      title="Weekly Report"
                      width="100px"
                    />
                  </Grid>
                </div>
              </div>
            ) : (
              ""
            )}

            {this.state.showSecion === "viewreports" ? (
              <div className="chartCont">
                <h4>Reports</h4>
                {this.state.chartData &&
                  this.state.chartData.map((item) => (
                    <div className="chartCont">
                      <div style={{ color: "white" }}>
                        {this.state.chartData[0].widgetName}
                      </div>
                      {this.getChartContainer(item)}
                    </div>
                  ))}
              </div>
            ) : (
              ""
            )}

            {this.state.showSecion === "viewWorkStream" ? (
              <div className="dataSetCont" id="rw-tab-header">
                <h4>Workstream</h4>
                <div
                  className="tblCont riskRegister dataGrids riskRegTable"
                  id="primedataset"
                >
                  <Grid
                    style={{ minHeight: "100px" }}
                    data={process(this.state.riskList, this.state.dataState)}
                    // data={this.state.riskList.slice(
                    //   this.state.skip,
                    //   this.state.take + this.state.skip
                    // )}
                    expandField="expanded"
                    onExpandChange={this.expandChange}
                    detail={MitigationDetails}
                    {...this.state.dataState}
                    onDataStateChange={(e) =>
                      this.setState({ dataState: e.dataState })
                    }
                    sortable={true}
                    pageable={true}
                    reorderable
                    resizable
                    // skip={this.state.skip}
                    // take={this.state.take}
                    // total={this.state.riskList.length}
                    // onPageChange={this.pageChange}
                  >
                    <Column
                      field="name"
                      title="Risk"
                      width="80px"
                      editable={false}
                      cell={(props) => (
                        <RiskDescriptionCell
                          {...props}
                          onEditCell={this.onEditCell}
                        />
                      )}
                    />
                    <Column
                      field="createdDate"
                      width="100px"
                      title="Created Date"
                      filter={"date"}
                      format="{0:dd-MMM-yyyy}"
                      editable={false}
                    />
                    <Column
                      field="createdByName"
                      width="100px"
                      title="Created By"
                      editable={false}
                    />
                    <Column field="number" title="Risk Number" width="100px" />
                    <Column
                      locked={true}
                      field="riskTitle"
                      title="Risk Title*"
                      width="150px"
                    />
                    <Column
                      field="isOpportunity"
                      title="T/O"
                      width="60px"
                      cell={(props) =>
                        props.dataItem.isOpportunity === "Threat" ? (
                          <td>{props.dataItem.isOpportunity}</td>
                        ) : (
                          <td>
                            <span className="turquoiseBlue">
                              {props.dataItem.isOpportunity}
                            </span>
                          </td>
                        )
                      }
                    />
                    <Column
                      field="riskTypeNames"
                      title="Risk Type"
                      width="150px"
                    />

                    {this.state.dropdownColumns}
                    <Column
                      field="cause"
                      title="Cause"
                      width="100px"
                      editable={false}
                      cell={(props) => (
                        <RiskCauseCell
                          {...props}
                          onEditCell={this.onEditCell}
                        />
                      )}
                    />
                    <Column
                      field="existingControl"
                      title="Existing Control"
                      width="100px"
                      editable={false}
                      cell={(props) => (
                        <ExistingControlCell
                          {...props}
                          onEditCell={this.onEditCell}
                        />
                      )}
                    />
                    <Column
                      field="frequency"
                      title="Pre-Probability (%)"
                      width="80px"
                      filter={"numeric"}
                    />
                    <Column
                      field="currentProbability"
                      title="Current Probability (%)"
                      width="80px"
                      editable={false}
                      cell={(props) => (
                        <td>
                          <span className="turquoiseBlue">
                            {props.dataItem.currentProbability}
                          </span>
                        </td>
                      )}
                    />
                    <Column
                      field="reductionProbability"
                      title="Post-Probability (%)"
                      width="75px"
                      editable={false}
                      cell={(props) => (
                        <td>
                          <span className="yellowCell">
                            {props.dataItem.reductionProbability}
                          </span>
                        </td>
                      )}
                      filter={"numeric"}
                    />

                    <Column
                      field="pre"
                      title="pre"
                      width="75px"
                      editable={false}
                      sortable={false}
                      cell={(props) => (
                        <PrePostComponenant
                          {...props}
                          onEditCell={this.onEditCell}
                          HeatMapConfigDataOpportunity={
                            this.state.HeatMapConfigDataOpportunity
                          }
                          HeatMapConfigDataThreat={
                            this.state.HeatMapConfigDataThreat
                          }
                          dynamicHeatmapProbabilityRange={
                            this.state.dynamicHeatmapProbabilityRange
                          }
                        />
                      )}
                    />
                    <Column
                      field="current"
                      title="current"
                      width="75px"
                      sortable={false}
                      editable={false}
                      cell={(props) => (
                        <PrePostComponenant
                          {...props}
                          onEditCell={this.onEditCell}
                          HeatMapConfigDataOpportunity={
                            this.state.HeatMapConfigDataOpportunity
                          }
                          HeatMapConfigDataThreat={
                            this.state.HeatMapConfigDataThreat
                          }
                          dynamicHeatmapProbabilityRange={
                            this.state.dynamicHeatmapProbabilityRange
                          }
                        />
                      )}
                    />
                    <Column
                      field="post"
                      title="post"
                      width="75px"
                      editable={false}
                      sortable={false}
                      cell={(props) => (
                        <PrePostComponenant
                          {...props}
                          onEditCell={this.onEditCell}
                          HeatMapConfigDataOpportunity={
                            this.state.HeatMapConfigDataOpportunity
                          }
                          HeatMapConfigDataThreat={
                            this.state.HeatMapConfigDataThreat
                          }
                          dynamicHeatmapProbabilityRange={
                            this.state.dynamicHeatmapProbabilityRange
                          }
                        />
                      )}
                    />
                    {/* <Column
                      field="overAll"
                      title="OverAll Impact"
                      width="100px"
                      editable={false}
                      sortable={false}
                      cell={(props) => (
                        <OverallComponenant
                          {...props}
                          onEditCell={this.onEditCell}
                        />
                      )}
                    /> */}
                    {/* New  */}

                    <Column
                      field="preRiskScore"
                      title="Risk Score (Pre)"
                      filter={"numeric"}
                      width="80px"
                      editable={false}
                    />

                    {isPrime && this.state.isValid === true ? (
                      <Column
                        field="preWeightedRiskScore"
                        title="Prime Risk Score (Pre)"
                        filter={"numeric"}
                        width="80px"
                        editable={false}
                        cell={(props) => (
                          <td>
                            <span>
                              {props.dataItem.isPrimeWorkstreams &&
                              secureLocalStorage.getItem("isPrime") == true
                                ? props.dataItem.preWeightedRiskScore
                                : ""}
                            </span>
                          </td>
                        )}
                      />
                    ) : null}

                    <Column
                      field="currentRiskScore"
                      title="Risk Score (Current)"
                      filter={"numeric"}
                      width="80px"
                      editable={false}
                      cell={(props) => (
                        <td>
                          <span className="turquoiseBlue">
                            {props.dataItem.currentRiskScore}
                          </span>
                        </td>
                      )}
                    />

                    {isPrime && this.state.isValid === true ? (
                      <Column
                        field="currentWeightedRiskScore"
                        title="Prime Risk Score (Current)"
                        filter={"numeric"}
                        width="80px"
                        editable={false}
                        cell={(props) => (
                          <td>
                            <span className="turquoiseBlue">
                              {props.dataItem.isPrimeWorkstreams &&
                              secureLocalStorage.getItem("isPrime") == true
                                ? props.dataItem.currentWeightedRiskScore
                                : ""}
                            </span>
                          </td>
                        )}
                      />
                    ) : null}

                    <Column
                      field="postRiskScore"
                      title="Risk Score (Post)"
                      filter={"numeric"}
                      width="80px"
                      editable={false}
                      cell={(props) => (
                        <td>
                          <span className="yellowCell">
                            {props.dataItem.postRiskScore}
                          </span>
                        </td>
                      )}
                    />

                    {isPrime && this.state.isValid === true ? (
                      <Column
                        field="postWeightedRiskScore"
                        title="Prime Risk Score (Post)"
                        filter={"numeric"}
                        width="80px"
                        editable={false}
                        cell={(props) => (
                          <td>
                            <span className="yellowCell">
                              {props.dataItem.isPrimeWorkstreams &&
                              secureLocalStorage.getItem("isPrime") == true
                                ? props.dataItem.postWeightedRiskScore
                                : ""}
                            </span>
                          </td>
                        )}
                      />
                    ) : null}
                    {/* End  */}
                    {this.state.impactColumns}
                    <Column
                      field="impactComments"
                      title="Consequences"
                      width="120px"
                      editable={false}
                    />
                    <Column
                      field="proximityDate"
                      title="Proximity Date"
                      width="120px"
                      editor="date"
                      filter={"date"}
                      editable={false}
                      format="{0:dd-MMM-yyyy}"
                    />
                    <Column
                      field="owner"
                      title="Owner"
                      width="120px"
                      editable={false}
                    />
                    <Column
                      field="updatedBy"
                      title="updated By"
                      width="120px"
                      editable={false}
                    />
                    <Column
                      field="riskFieldsCompletion"
                      title="% of fields completed"
                      width="120px"
                      editable={false}
                    />
                    <Column
                      field="isClosed"
                      title="Status"
                      width="70px"
                      // editor="boolean"
                      editable={false}
                      cell={(props) => (
                        <StatusComponent
                          {...props}
                          onEditCell={this.onEditCell}
                        />
                      )}
                      filter={"boolean"}
                    />
                  </Grid>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>

        <ExcelExport
          data={this.state.mitigationData}
          // ref={(exporter) => { this._exporter = exporter }}
          ref={this._exporterAction}
        >
          <ExcelExportColumn
            field="organisationName"
            title="Workstream"
            width="200px"
          />
          <ExcelExportColumn
            field="riskNumber"
            title="Risk Number"
            width="200px"
          />
          <ExcelExportColumn
            field="riskTitle"
            title="Risk Title"
            width="200px"
          />
          <ExcelExportColumn
            field="riskName"
            title="Risk Description"
            width="200px"
          />
          <ExcelExportColumn field="isOpportunity" title="T/O" width="200px" />
          <ExcelExportColumn field="name" title="Action Title" width="200px" />
          <ExcelExportColumn
            field="number"
            title="Action Number"
            width="120px"
          />
          <ExcelExportColumn
            field="control"
            title="Description"
            width="150px"
            editable={false}
          />
          <ExcelExportColumn
            field="externalReference"
            title="External Reference"
            width="150px"
            editable={false}
          />
          <ExcelExportColumn
            field="actionType"
            title="Action Type"
            width="150px"
            editable={false}
          />
          {/* <ExcelExportColumn
            field="riskTypeNames"
            title="Risk Type"
            width="150px"
            editable={false}
          /> */}
          <ExcelExportColumn
            field="riskTypeNames"
            title="Risk Type"
            width="150px"
            editable={false}
          />
          {this.state.dropdownColumns}
          <ExcelExportColumn
            field="cost"
            title={"Cost of Action / " + secureLocalStorage.getItem("currency")}
            width="80px"
            cell={(props) => (
              <CurrencyFormat {...props} onEditCell={this.onEditCell} />
            )}
          />
          <ExcelExportColumn
            field="reductionFrequency"
            width="80px"
            title="Change in Probability  (%)"
            cell={(props) => (
              <CurrencyFormat {...props} onEditCell={this.onEditCell} />
            )}
          />
          {this.state.impactColumnsExport}
          <ExcelExportColumn
            field="spi"
            title="% On Track"
            width="80px"
            filter={"number"}
          />
          <ExcelExportColumn
            field="percentageCompletion"
            title="% Completion"
            width="150px"
          />
          
          <ExcelExportColumn
            field="projectedCompletionDate"
            width="100px"
            title="Project Completion Date"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <ExcelExportColumn
            field="projectedCompletionDate"
            width="100px"
            title="Project Completion Date"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <ExcelExportColumn
            field="originalCompletionDate"
            width="100px"
            title="Original Completion Date"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <ExcelExportColumn
            field="actualCompletionDate"
            width="100px"
            title="Actual Completion Date"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <ExcelExportColumn
            field="proximityDate"
            width="100px"
            title="Proximity Alert Date"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <ExcelExportColumn
            field="createdDate"
            width="100px"
            title="Created Date"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <ExcelExportColumn
            field="createdByName"
            width="100px"
            title="Created By"
          />
          <ExcelExportColumn field="owner" width="100px" title="Owner" />
          <ExcelExportColumn
            field="actionFieldsCompletion"
            width="100px"
            title="% of fields completed"
          />
          <ExcelExportColumn
            field="approved"
            width="100px"
            title="Approved"
            cell={CheckBox}
            filter={"boolean"}
          />
          <ExcelExportColumn
            field="updatedDate"
            width="100px"
            title="Updated Date"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <ExcelExportColumn
            field="updatedBy"
            width="100px"
            title="Updated By"
          />

          <ExcelExportColumn field="isOpen" width="100px" title="Status" />

          <ExcelExportColumn
            field="departments"
            title="Departments"
            width="150px"
          />
          <ExcelExportColumn
            field="externalStatus"
            title="External Status"
            width="120px"
          />
          <ExcelExportColumn
            field="weeklyReport"
            title="Weekly Report"
            width="100px"
          />

          <ExcelExportColumn
            field="progressHistory"
            title="Progress Status History"
            width="200px"
            cellOptions={{
              wrap: true,
              textAlign: "left",
              verticalAlign: "top",
            }}
          />
        </ExcelExport>

        <ExcelExport
          data={this.state.riskList}
          // ref={(exporter) => { this._exporter = exporter }}
          ref={this._exporterRisk}
        >
          <ExcelExportColumn
            field="organizationUnitName"
            title="Workstream"
            width="100px"
          />
          <ExcelExportColumn field="number" title="Risk Number" width="100px" />
          <ExcelExportColumn
            locked={true}
            field="riskTitle"
            title="Risk Title*"
            width="150px"
          />
          <ExcelExportColumn field="isOpportunity" title="T/O" width="60px" />
          <ExcelExportColumn
            field="name"
            title="Risk Description"
            width="80px"
            editable={false}
            cell={(props) => (
              <RiskDescriptionCell {...props} onEditCell={this.onEditCell} />
            )}
          />

          <ExcelExportColumn
            field="riskTypeNames"
            title="Risk Type"
            width="150px"
          />

          {this.state.dropdownColumns}
          <ExcelExportColumn
            field="cause"
            title="Cause"
            width="100px"
            editable={false}
            cell={(props) => (
              <RiskCauseCell {...props} onEditCell={this.onEditCell} />
            )}
          />
          <ExcelExportColumn
            field="existingControl"
            title="Existing Control"
            width="100px"
            editable={false}
            cell={(props) => (
              <ExistingControlCell {...props} onEditCell={this.onEditCell} />
            )}
          />
          <ExcelExportColumn
            field="frequency"
            title="Pre-Probability (%)"
            width="80px"
            filter={"numeric"}
          />
          <ExcelExportColumn
            field="currentProbability"
            title="Current Probability (%)"
            width="75px"
            editable={false}
            cell={(props) => (
              <td>
                <span className="turquoiseBlue">
                  {props.dataItem.currentProbability}
                </span>
              </td>
            )}
            filter={"numeric"}
          />
          <ExcelExportColumn
            field="reductionProbability"
            title="Post-Probability (%)"
            width="75px"
            editable={false}
            cell={(props) => (
              <td>
                <span className="yellowCell">
                  {props.dataItem.reductionProbability}
                </span>
              </td>
            )}
            filter={"numeric"}
          />

          <ExcelExportColumn
            field="pre"
            title="pre"
            width="75px"
            editable={false}
            sortable={false}
            cell={(props) => (
              <PrePostComponenant
                {...props}
                onEditCell={this.onEditCell}
                HeatMapConfigDataOpportunity={
                  this.state.HeatMapConfigDataOpportunity
                }
                HeatMapConfigDataThreat={this.state.HeatMapConfigDataThreat}
                dynamicHeatmapProbabilityRange={
                  this.state.dynamicHeatmapProbabilityRange
                }
              />
            )}
          />
          <ExcelExportColumn
            field="current"
            title="current"
            width="75px"
            editable={false}
            sortable={false}
            cell={(props) => (
              <PrePostComponenant
                {...props}
                onEditCell={this.onEditCell}
                HeatMapConfigDataOpportunity={
                  this.state.HeatMapConfigDataOpportunity
                }
                HeatMapConfigDataThreat={this.state.HeatMapConfigDataThreat}
                dynamicHeatmapProbabilityRange={
                  this.state.dynamicHeatmapProbabilityRange
                }
              />
            )}
          />
          <ExcelExportColumn
            field="post"
            title="post"
            width="75px"
            editable={false}
            sortable={false}
            cell={(props) => (
              <PrePostComponenant
                {...props}
                onEditCell={this.onEditCell}
                HeatMapConfigDataOpportunity={
                  this.state.HeatMapConfigDataOpportunity
                }
                HeatMapConfigDataThreat={this.state.HeatMapConfigDataThreat}
                dynamicHeatmapProbabilityRange={
                  this.state.dynamicHeatmapProbabilityRange
                }
              />
            )}
          />
          {/* <ExcelExportColumn
            field="overAll"
            title="OverAll Impact"
            width="100px"
            editable={false}
            sortable={false}
            cell={(props) => (
              <OverallComponenant {...props} onEditCell={this.onEditCell} />
            )}
          /> */}
          {/* New  */}

          <ExcelExportColumn
            field="preRiskScore"
            title="Risk Score (Pre)"
            filter={"numeric"}
            width="80px"
            editable={false}
          />

          {isPrime && (
            <ExcelExportColumn
              field="preWeightedRiskScore"
              title="Prime Risk Score (Pre)"
              filter={"numeric"}
              width="80px"
              editable={false}
              cell={(props) => (
                <td>
                  <span>
                    {props.dataItem.isPrimeWorkstreams &&
                    secureLocalStorage.getItem("isPrime") == true
                      ? props.dataItem.preWeightedRiskScore
                      : ""}
                  </span>
                </td>
              )}
            />
          )}

          <ExcelExportColumn
            field="currentRiskScore"
            title="Risk Score (Current)"
            filter={"numeric"}
            width="80px"
            editable={false}
            cell={(props) => (
              <td>
                <span className="turquoiseBlue">
                  {props.dataItem.currentRiskScore}
                </span>
              </td>
            )}
          />

          {ExcelExportColumn && (
            <Column
              field="currentWeightedRiskScore"
              title="Prime Risk Score (Current)"
              filter={"numeric"}
              width="80px"
              editable={false}
              cell={(props) => (
                <td>
                  <span className="turquoiseBlue">
                    {props.dataItem.isPrimeWorkstreams &&
                    secureLocalStorage.getItem("isPrime") == true
                      ? props.dataItem.currentWeightedRiskScore
                      : ""}
                  </span>
                </td>
              )}
            />
          )}

          <ExcelExportColumn
            field="postRiskScore"
            title="Risk Score (Post)"
            filter={"numeric"}
            width="80px"
            editable={false}
            cell={(props) => (
              <td>
                <span className="yellowCell">
                  {props.dataItem.postRiskScore}
                </span>
              </td>
            )}
          />

          {isPrime && (
            <ExcelExportColumn
              field="postWeightedRiskScore"
              title="Prime Risk Score (Post)"
              filter={"numeric"}
              width="80px"
              editable={false}
              cell={(props) => (
                <td>
                  <span className="yellowCell">
                    {props.dataItem.isPrimeWorkstreams &&
                    secureLocalStorage.getItem("isPrime") == true
                      ? props.dataItem.postWeightedRiskScore
                      : ""}
                  </span>
                </td>
              )}
            />
          )}
          {/* End  */}
          {this.state.impactColumns}
          <ExcelExportColumn
            field="impactComments"
            title="Consequences"
            width="120px"
            editable={false}
          />
          <ExcelExportColumn
            field="progressHistory"
            title="Progress Status History"
            width="200px"
            cellOptions={{
              wrap: true,
              textAlign: "left",
              verticalAlign: "top",
            }}
          />
          <ExcelExportColumn
            field="proximityDate"
            title="Proximity Date"
            width="120px"
            editor="date"
            filter={"date"}
            editable={false}
            format="{0:dd-MMM-yyyy}"
          />
          <ExcelExportColumn
            field="createdDate"
            width="100px"
            title="Created Date"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <ExcelExportColumn
            field="createdByName"
            width="100px"
            title="Created By"
          />
          <ExcelExportColumn
            field="updatedDate"
            title="Updated Date"
            width="120px"
            editor="date"
            filter={"date"}
            editable={false}
            format="{0:dd-MMM-yyyy}"
          />
          <ExcelExportColumn
            field="updatedBy"
            title="Updated By"
            width="120px"
            editable={false}
          />
          <ExcelExportColumn
            field="owner"
            title="Owner"
            width="120px"
            editable={false}
          />
          <ExcelExportColumn
            field="riskFieldsCompletion"
            title="% of fields completed"
            width="120px"
            editable={false}
          />

          <ExcelExportColumn
            field="isClosed"
            title="Status"
            width="70px"
            // editor="boolean"
            editable={false}
            cell={(props) => (
              <StatusComponent {...props} onEditCell={this.onEditCell} />
            )}
            filter={"boolean"}
          />
        </ExcelExport>

        <ExcelExport
          data={this.state.taskList}
          ref={this._exporterTask}
          headerPaddingCellOptions={{
            background: "#ff0000",
          }}
        >
          <ExcelExportColumn field="taskNumber" title="Task Number" width="200px" />
          <ExcelExportColumn
            field="isApproved"
            title="Approved"
            width="200px"
          />
          <ExcelExportColumn
            field="taskTitle"
            title="Task Title"
            width="200px"
          />
          <ExcelExportColumn
            field="taskDescription"
            title="Task Description"
            width="200px"
          />
          <ExcelExportColumn
            field="cost"
            title={
              "Cost of Activity" + " / " + secureLocalStorage.getItem("currency")
            }
            width="200px"
          />
          <ExcelExportColumn field="effort" title={"Effort"} width="200px" />
          <ExcelExportColumn
            field="percentageOnTrack"
            title="% on Track"
            width="200px"
          />
          <ExcelExportColumn
            field="percentageCompletion"
            title="% Completion"
            width="200px"
          />
          <ExcelExportColumn
            field="priorityRankingName"
            title="Priority Ranking"
            width="200px"
          />
          {this.state.dropdownColumns}
          <ExcelExportColumn
            field="originalCompletionDate"
            title="Original Completion Date"
            width="200px"
          />
          <ExcelExportColumn
            field="projectedCompletionDate"
            title="Projected Completion Date"
            width="200px"
          />
          <ExcelExportColumn
            field="actualCompletionDate"
            title="Actual Completion Date"
            width="200px"
          />
          <ExcelExportColumn
            field="proximityAlertDate"
            title="Proximity Alert Date"
            width="200px"
          />
          <ExcelExportColumn
            field="delayConsequence"
            title="Delay Consequence"
            width="200px"
          />
          <ExcelExportColumn
            field="alertStakeHolders"
            title="Alert Stakeholders"
            width="200px"
          />
          <ExcelExportColumn
            field="alertDescription"
            title="Alert Description"
            width="200px"
          />
          <ExcelExportColumn
            field="ownerName"
            title="Activity Owner"
            width="200px"
          />
          <ExcelExportColumn
            field="createdDate"
            title="Created Date"
            width="200px"
          />
          <ExcelExportColumn
            field="createdByName"
            title="Created By"
            width="200px"
          />
          <ExcelExportColumn
            field="updatedDate"
            title="Updated Date"
            width="200px"
            filter={"date"}
          />
          <ExcelExportColumn
            field="updatedByName"
            title="Updated By"
            width="200px"
          />
          <ExcelExportColumn
            field="closedDate"
            title="Closed Date"
            width="200px"
            filter={"date"}
          />
          <ExcelExportColumn field="isClosed" title="Status" width="200px" />

          <ExcelExportColumn
            field="departments"
            title="Departments"
            width="150px"
          />
          <ExcelExportColumn
            field="externalStatus"
            title="External Status"
            width="120px"
          />
          <ExcelExportColumn
            field="weeklyReport"
            title="Weekly Report"
            width="100px"
          />

          <ExcelExportColumn
            field="progressHistory"
            title="Progress Status History"
            width="200px"
            cellOptions={{
              wrap: true,
              textAlign: "left",
              verticalAlign: "top",
            }}
          />
        </ExcelExport>

        <ExcelExport
          data={this.state.taskActionList}
          ref={this._exporterTaskAction}
          headerPaddingCellOptions={{
            background: "#ff0000",
          }}
        >
          <ExcelExportColumn
            field="organizationUnitName"
            title="Workstream"
            width="200px"
          />
          <ExcelExportColumn
            field="taskNumber"
            title="Task Number"
            width="200px"
          />
          <ExcelExportColumn
            field="taskTitle"
            title="Task Title"
            width="200px"
          />
          <ExcelExportColumn
            field="taskActionNumber"
            title="Activity Number"
            width="200px"
          />
          <ExcelExportColumn
            field="isApproved"
            title="Approved"
            width="200px"
          />
          <ExcelExportColumn
            field="taskActionTitle"
            title="Activity Title"
            width="200px"
          />
          <ExcelExportColumn
            field="taskActionDescription"
            title="Activity Description"
            width="200px"
          />
          <ExcelExportColumn
            field="cost"
            title={
              "Cost of Activity" + " / " + secureLocalStorage.getItem("currency")
            }
            width="200px"
          />
          <ExcelExportColumn field="effort" title={"Effort"} width="200px" />
          <ExcelExportColumn
            field="percentageOnTrack"
            title="% on Track"
            width="200px"
          />
          <ExcelExportColumn
            field="percentageCompletion"
            title="% Completion"
            width="200px"
          />
          <ExcelExportColumn
            field="priorityRankingName"
            title="Priority Ranking"
            width="200px"
          />
          {this.state.dropdownColumns}
          <ExcelExportColumn
            field="originalCompletionDate"
            title="Original Completion Date"
            width="200px"
          />
          <ExcelExportColumn
            field="projectedCompletionDate"
            title="Projected Completion Date"
            width="200px"
          />
          <ExcelExportColumn
            field="actualCompletionDate"
            title="Actual Completion Date"
            width="200px"
          />
          <ExcelExportColumn
            field="proximityAlertDate"
            title="Proximity Alert Date"
            width="200px"
          />
          <ExcelExportColumn
            field="delayConsequence"
            title="Delay Consequence"
            width="200px"
          />
          <ExcelExportColumn
            field="alertStakeHolders"
            title="Alert Stakeholders"
            width="200px"
          />
          <ExcelExportColumn
            field="alertDescription"
            title="Alert Description"
            width="200px"
          />
          <ExcelExportColumn
            field="ownerName"
            title="Activity Owner"
            width="200px"
          />
          <ExcelExportColumn
            field="createdDate"
            title="Created Date"
            width="200px"
          />
          <ExcelExportColumn
            field="createdByName"
            title="Created By"
            width="200px"
          />
          <ExcelExportColumn
            field="updatedDate"
            title="Updated Date"
            width="200px"
            filter={"date"}
          />
          <ExcelExportColumn
            field="updatedByName"
            title="Updated By"
            width="200px"
          />
          <ExcelExportColumn
            field="closedDate"
            title="Closed Date"
            width="200px"
            filter={"date"}
          />
          <ExcelExportColumn field="isClosed" title="Status" width="200px" />

          <ExcelExportColumn
            field="departments"
            title="Departments"
            width="150px"
          />
          <ExcelExportColumn
            field="externalStatus"
            title="External Status"
            width="120px"
          />
          <ExcelExportColumn
            field="weeklyReport"
            title="Weekly Report"
            width="100px"
          />

          <ExcelExportColumn
            field="progressHistory"
            title="Progress Status History"
            width="200px"
            cellOptions={{
              wrap: true,
              textAlign: "left",
              verticalAlign: "top",
            }}
          />
        </ExcelExport>
        <div className="widgetContainer">
          <div className="wGridCont">
            {this.state.chartComponentArray &&
              this.state.chartComponentArray.map((item) => (
                // <div className="chartCont"  id={"c" + item.chartPdfId}>{item.chartHtml}</div>

                <div className="wGrid">
                  <div className="wGBox" id={"c" + item.chartPdfId}>
                    <div className="wgHeader">
                      <h4>
                        <b>{item.chartWidName}</b>
                      </h4>
                    </div>
                    <div className="chartCont">{item.chartHtml}</div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <Popup show={this.state.showEmailTemplate} popupClass={"popup-content"}>
          <div className="addToCart">
            <h3>
              {this.state.templateFlag === "ADD"
                ? "Create a new Template"
                : "Update a new Template"}
            </h3>
            <div className="formCont">
              <div className="fieldCol rm-dropdown">
                <div className="fieldCont">
                  <label>Template Name</label>
                  <input
                    type="text"
                    autoComplete="off"
                    value={this.state.name}
                    onChange={(e) =>
                      this.setState({
                        name: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="formCont">
              <div className="fieldCol rm-dropdown">
                <div className="fieldCont">
                  <label>Description</label>
                  <textarea
                    autoComplete="off"
                    value={this.state.description}
                    onChange={(e) =>
                      this.setState({
                        description: e.target.value,
                      })
                    }
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="btnGroup">
              <button
                type="button"
                disabled={!this.state.name}
                onClick={() =>
                  this.state.templateFlag === "ADD"
                    ? this.saveTemplate()
                    : this.UpdateTemplate()
                }
                className="btnPrimary"
              >
                {this.state.templateFlag === "ADD" ? "Submit" : "Update"}
              </button>
              <button
                type="button"
                onClick={() => this.closeAddTemplate()}
                className="btnCancel"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
